<template>
  <div class="contenedor">
    <div class="row">
      <div class="col-12">
        <!-- <div class="row mb-2"> -->
        <!-- <div
            class="col-12"
            v-if="currentUser.role_id !== '4' && clientId == null"
          >
            <TabItem
              :status="tab == 1"
              :id="1"
              :label="$t('lang.label.agency')"
              :icon="'icon-bar-chart'"
              @change="changeThisTab($event)"
              v-if="hasPermissions('adminClients')"
            >
            </TabItem>

            <TabItem
              :status="tab == 7"
              :id="7"
              :label="'Warmy'"
              :icon="'icon-exchange'"
              @change="changeThisTab($event)"
              v-if="hasPermissions('superAdmin')"
            >
            </TabItem>

            <TabItem
              :status="tab == 8"
              :id="8"
              :label="'Meetings'"
              :icon="'icon-calendar'"
              @change="changeThisTab($event)"
              v-if="hasPermissions('superAdmin')"
            >
            </TabItem>

            <TabItem
              :status="tab == 3"
              :id="3"
              :label="'Workspaces'"
              :icon="'icon-group'"
              @change="changeThisTab($event)"
              v-if="hasPermissions('superAdmin')"
            >
            </TabItem>

            <TabItem
              :status="tab == 10"
              :id="10"
              :label="'QueueEmails'"
              :icon="'icon-email'"
              @change="changeThisTab($event)"
              v-if="hasPermissions('superAdmin')"
            >
            </TabItem>

            <TabItem
              :status="tab == 11"
              :id="11"
              :label="'Email Accounts'"
              :icon="'icon-mail'"
              @change="changeThisTab($event)"
              v-if="hasPermissions('superAdmin')"
            >
            </TabItem>

            <TabItem
              :status="tab == 19"
              :id="19"
              :label="'Business Contacts'"
              :icon="'icon-mail'"
              @change="changeThisTab($event)"
              v-if="hasPermissions('superAdmin')"
            >
            </TabItem>

            <TabItem
              :status="tab == 22"
              :id="22"
              :label="'Meetings dispertion'"
              :icon="'icon-calendar'"
              @change="changeThisTab($event)"
              v-if="hasPermissions('superAdmin')"
            >
            </TabItem>

            <TabItem
              :status="tab == 13"
              :id="13"
              :label="'BDR Performances'"
              :icon="'icon-bar-chart'"
              @change="changeThisTab($event)"
              v-if="hasPermissions('superAdmin')"
            >
            </TabItem>

            <TabItem
              :status="tab == 14"
              :id="14"
              :label="'Report Credit'"
              :icon="'icon-bar-chart'"
              @change="changeThisTab($event)"
              v-if="hasPermissions('superAdmin')"
            >
            </TabItem>

            <TabItem
              :status="tab == 18"
              :id="18"
              :label="'Live Domain IP'"
              :icon="'icon-feed'"
              @change="changeThisTab($event)"
              v-if="hasPermissions('superAdmin')"
            >
            </TabItem>

            <TabItem
              :status="tab == 21"
              :id="21"
              :label="'Metrics'"
              :icon="'icon-bar-chart'"
              @change="changeThisTab($event)"
              v-if="hasPermissions('superAdmin')"
            >
            </TabItem>

          </div> -->
        <!-- </div> -->

        <div class="col-12" v-if="tab == 12">
          <AllEmails :isDashboard="true" />
        </div>



        <!-- Tab -> Report Credit. -->
        <div class="col-12 p-0" v-if="tab == 14">
          <DashboardReportCredit dashboardType="bdr" userId="4128" />
        </div>
        <!-- End - Tab -> Report Credit -->

        <div class="col-4">
          <h2>{{ getTittle() }}</h2>
        </div>
        <AccountEmailList v-if="tab == 11"></AccountEmailList>
        <BusinessContactEmailList v-if="tab == 19" :query="this.$route.query"></BusinessContactEmailList>

        <div v-show="!isMobile" class=" w-100  stats-wrapper  card py-2" v-if="tab == 1 || tab == 8 || tab == 21 || tab == 22">
          <div class="d-flex flex-wrap text-secondary">

            <div class="w-25 input-group input-group-sm p-1 treeselect-wrapper"
              v-if="tab == 1 || tab == 8 || tab == 22">
              <div class="input-group-prepend ">
                <small class="p-2" id="inputGroup-sizing-sm">Category stats</small>
              </div>
              <select class="form-control" v-model="type_stats">
                <option value="">Select a category</option>
                <option value="revenue">Revenue</option>
                <option value="meetings">Meetings</option>
                <option value="sendings">Sendings</option>
                <option value="clicks_answers">Clics & Answers</option>
                <option value="projections">Projections</option>
                <option value="calls">Calls</option>
                <option value="data">Data</option>
                <option value="bookers">Bookers</option>
                <option value="account_management">Account Management</option>
              </select>
            </div>

            <div class="w-25 input-group input-group-sm p-1 treeselect-wrapper"
              v-if="tab == 1 || tab == 8 || tab == 22">
              <div class="input-group-prepend ">
              </div>
              <treeselect 
                @input="filterTypeChanged" 
                v-model="filters.type" 
                :options="filteredOptionsByCategory" 
                :multiple="true" 
                :disabled="tab === 8 || tab === 22 ? true : !type_stats"
                class="form-control inline-table">
              </treeselect>
            </div>

            <div class="w-50 input-group input-group-sm p-1" v-if="tab == 1 || tab == 8 || tab == 21 || tab == 22">
              <div class="input-group-prepend">
                <small class="p-2" id="inputGroup-sizing-sm">From</small>
              </div>
              <date-picker id="startDatePicker" class="form-control" v-model="range.startDate"
                :config="datePickerConfig" placeholder="Start Date"></date-picker>


              <div class="input-group-prepend">
                <small class="p-2" id="inputGroup-sizing-sm">to</small>
              </div>
              <date-picker id="endDatePicker" class="form-control" v-model="range.endDate"
                :config="datePickerConfigEndDate" placeholder="End Date"></date-picker>
            </div>

            <div class="w-100 px-1 py-1 d-flex justify-content-end" v-if="tab == 1 || tab == 8 || tab == 22">
              <a href="javascript:void(0)" class="text-primary" @click="toggleAdvancedFilters">
                {{ showAdvancedFilters ? 'Advanced filters −' : 'Advanced filters +' }}
              </a>
            </div>

            <div class="w-50 input-group input-group-sm p-1 treeselect-wrapper" v-if="
              (tab == 21 || showAdvancedFilters) &&
              currentUser.role_id !== '4' &&
              clientId == null &&
              (tab == 1 || tab == 8 || tab == 21 || tab == 22)
            ">
              <div class="input-group-prepend">
                <small class="p-2" id="inputGroup-sizing-sm">Clients</small>
              </div>
              <treeselect tag-placeholder="Add this as new tag" v-bind:placeholder="$t('lang.label.searchoraddatag')"
                v-model="clients" :loadOptions="searchOptions" :limit="40" :multiple="true" :taggable="false"
                :disabled="tab === 22 ? true : false" :searchable="true" :showLabels="true" openDirection="below"
                class="form-control inline-table" :async="true" :defaultOptions="defaulOptions">
              </treeselect>
            </div>


            <div class="w-50 input-group input-group-sm p-1" v-if="(tab == 21 || showAdvancedFilters) && (tab == 1 || tab == 8 || tab == 21 || tab == 22)">
              <div class="input-group-prepend">
                <small class="p-2" id="inputGroup-sizing-sm">Signed On</small>
              </div>
              <date-picker id="startDatePicker" class="form-control" v-model="filters.clientSignedOn.startDate"
                :config="datePickerConfig" placeholder="Start Date"></date-picker>

              <div class="input-group-prepend">
                <small class="p-2" id="inputGroup-sizing-sm">
                  to</small>
              </div>
              <date-picker id="startDatePicker" class="form-control" v-model="clientSignedOn.endDate"
                :config="datePickerConfig" placeholder="End Date"></date-picker>
            </div>


            <div class="w-25 input-group input-group-sm p-1 treeselect-wrapper"
              v-if="(tab == 21 || showAdvancedFilters) && (tab == 1 || tab == 8 || tab == 22)">
              <div class="input-group-prepend">
                <small class="p-2" id="inputGroup-sizing-sm">{{ $t("lang.token.order_language") }}</small>
              </div>
              <treeselect v-model="filters.orderLanguage" :options="langs" :multiple="true" :value="value"
                :normalizer="normalizerLangs" :disabled="includeOption('billing')" class="form-control inline-table">
              </treeselect>
            </div>


            <div class="w-25 input-group input-group-sm p-1 treeselect-wrapper"
              v-if="(tab == 21 || showAdvancedFilters) && (tab == 1 || tab == 8 || tab == 22)">
              <div class="input-group-prepend">
                <small class="p-2" id="inputGroup-sizing-sm">Warmup</small>
              </div>
              <treeselect v-model="filters.warmupActive" :options="warmupActiveOptions" :multiple="false"
                :disabled="includeOption('billing')" class="form-control inline-table">
              </treeselect>
            </div>


            <div class="w-50 input-group input-group-sm p-1" v-if="(tab == 21 || showAdvancedFilters) && (tab == 1 || tab == 8 || tab == 22)">
              <div class="input-group-prepend">
                <small class="p-2" id="inputGroup-sizing-sm">Launched</small>
              </div>
              <date-picker id="startDatePicker" class="" v-model="filters.launchDate.startDate"
                :config="datePickerConfig" placeholder="Start Date"></date-picker>

              <div class="input-group-prepend">
                <small class="p-2" id="inputGroup-sizing-sm">to</small>
              </div>
              <date-picker id="endDatePicker" class="" v-model="launchDate.endDate" :config="datePickerConfigEndDate"
                placeholder="End Date"></date-picker>
            </div>


            <div class="col-4 input-group input-group-sm p-1 treeselect-wrapper"
              v-if="false && (tab == 1 || tab == 8 || tab == 22)">
              <div class="input-group-prepend">
                <small class="p-2" id="inputGroup-sizing-sm">Sending IPs</small>
              </div>
              <treeselect v-model="filters.sendingIps" :options="sendingIps" :multiple="true"
                :disabled="true || includeOption('billing')" class="form-control inline-table">
              </treeselect>
            </div>


            <div class="col-md-6 input-group input-group-sm p-1 treeselect-wrapper"
              v-if="(tab == 21 || showAdvancedFilters) && (tab == 1 || tab == 8 || tab == 22)">
              <div class="input-group-prepend">
                <small class="p-2" id="inputGroup-sizing-sm">Sending Methods</small>
              </div>
              <treeselect v-model="filters.sendingMethods" :options="sendingMethods" :multiple="true"
                :disabled="includeOption('billing')" class="form-control inline-table" :show-count="true">
              </treeselect>
            </div>


            <div class="col-md-4 col-sm-100 w-25 input-group input-group-sm p-1 treeselect-wrapper"
              v-if="(tab == 21 || showAdvancedFilters) && (tab == 1 || tab == 8 || tab == 22)">
              <div class="input-group-prepend">
                <small class="p-2" id="inputGroup-sizing-sm">Providers</small>
              </div>
              <treeselect v-model="filters.sendingProviders" :options="sendingProviders" :multiple="true"
                :disabled="includeOption('billing')" class="form-control inline-table">
              </treeselect>
            </div>

            <div class="col-md-12 d-flex justify-content-end my-2 ml-auto" v-if="tab == 1">
              <button class="btn btn-primary" :disabled="loadingStats" @click="loadRangeStats()">
                <i class="icon-search mr-2"></i>
                <small>
                  {{ $t("lang.label.letsgetstarted") }}
                </small>
              </button>
            </div>

            <div class="w-25 p-1 ml-auto">

              <div class="col-md-2 d-flex justify-content-start my-0" v-if="tab == 21">
                <button class="btn btn-success" :disabled="loadingStats" @click="getDataMetrics = !getDataMetrics">
                  <i class="icon-calendar-check-o mr-2"></i>
                  <small> Validate </small>
                </button>
              </div>


            </div>
          </div>
        </div>

        <div class="mt-3 card p-2" v-if="tab == 1 && openchart">

          <div class="w-100">
            <button class="btn btn-sm btn-outline-primary" :class="timechart == 'day' ? 'active' : ''"
              @click="changeChart('day')">
              <small>
                {{ $t("lang.label.days") }}
              </small>
            </button>
            <button class="btn btn-sm  btn-outline-primary ml-2" :class="timechart == 'week' ? 'active' : ''"
              @click="changeChart('week')">
              <small>
                {{ $t("lang.label.weeks") }}
              </small>
            </button>
            <button class="btn btn-sm  btn-outline-primary ml-2" :class="timechart == 'month' ? 'active' : ''"
              @click="changeChart('month')">
              <small>
                {{ $t("lang.label.months") }}
              </small>
            </button>

          </div>

          <LoadingSpinner v-if="loadingStats" />

          <div v-if="!loadingStats" style="overflow: scroll">
            <div class="row" v-if="false">
              <div class="col-12">
                <line-chart :class="timechart == 'day' ? 'd-block' : 'd-none'" :width="300" :height="400"
                  :chart-data="groupedmeetigns" :options="groupedmeetigns.options" /> 

                <line-chart v-if="timechart == 'week'" :width="300" :height="400" :chart-data="groupedmeetignsweek"
                  :options="groupedmeetignsweek.options" />

                <line-chart v-if="timechart == 'month'" :width="300" :height="400" :chart-data="groupedmeetignsmonth"
                  :options="groupedmeetignsmonth.options" />
              </div>
            </div>

            <div style="min-width: 800px">
              <line-chart :class="timechart == 'week' ? 'd-block' : 'd-none'" v-if="multiaxisweek.datasets.length > 0"
                :width="300" :height="100" :chart-data="multiaxisweek" :options="multiaxisweek.options" />
              <line-chart :class="timechart == 'day' ? 'd-block' : 'd-none'" v-if="multiaxis.datasets.length > 0"
                :width="300" :height="100" :chart-data="multiaxis" :options="multiaxis.options" />
              <line-chart :class="timechart == 'month' ? 'd-block' : 'd-none'" v-if="multiaxismonth.datasets.length > 0"
                :width="300" :height="100" :chart-data="multiaxismonth" :options="multiaxismonth.options" />
            </div>
          </div>
        </div>

        <!-- <div v-if="tab == 1 && hasPermissions('superAdmin')">
          <button class="btn btn-success mt-2" @click="loadAgencyStats()">
            <i class="icon-list mr-2"></i>
            <small> {{ $t("lang.button.list") }} </small>
          </button>
        </div> -->
        <div v-if="(tab == 8 || tab == 22) && hasPermissions('adminAgency')">
          <button class="btn btn-success mt-2" @click="loadAgencyStats()">
            <i class="icon-list mr-2"></i>
            <small> {{ $t("lang.button.list") }} </small>
          </button>
        </div>

        <!-- <div v-if="tab == 1 && hasPermissions('superAdmin')">
          <button class="btn btn-success mt-2" @click="loadRappelActivity()">
            <i class="icon-phone mr-2"></i>
            <small> {{ $t("lang.button.rappel_history") }}</small>
          </button>
        </div> -->

        <div class="card no-border mt-3" v-if="tab == 1 && openrappellist">
          <table class="mt-2 ml-2">
            <thead>
              <tr>
                <td>{{ $t("lang.column.opportunity") }}</td>
                <td>{{ $t("lang.column.quantity") }}</td>
                <td>{{ $t("lang.column.status") }}</td>
                <td>{{ $t("lang.column.tags") }}</td>
                <td>{{ $t("lang.column.Last_status_update") }}</td>
              </tr>
            </thead>
            <tr v-for="rappel in rappellist" class="bg-light border-top">
              <td>
                <strong><a class="text-primary ml-2 ml-2" target="_blank"
                    :href="'/opportunities/' + rappel.link_id">Opportunity</a></strong>
              </td>
              <td>{{ rappel.cant }}</td>
              <td>
                <span :class="getClass(rappel)">{{ getText(rappel) }}</span>
              </td>
              <td>{{ rappel.link_tag }}</td>
              <td>{{ rappel.creation_date }}</td>
            </tr>
          </table>
        </div>
        <div class="float-right" v-if="tab == 8">
          <FilterSystem class="float-right mr-2" :columns="filterColumns" :reset="resetFilterSystem" :sort="sort"
            :dir="dir" :filterSystem="filtersDash" :filterOldQuery="oldQuery" :key="filterkey"
            @callApi="filterNow($event)" v-if="tab != 18" />
        </div>

        <div class="card no-border mt-3" v-if="tab == 1 && openlist">
          <template v-if="!graphsDataLoading">
            <div class="row">
              <div class="col-md-3">
                <div class="p-3">
                  <span class="card p-2 mb-2 text-center">
                    <h6>Total Opp</h6>
                    <h4>{{ meetings_details.length }}</h4>
                  </span>

                  <span class="card p-2 mb-2 text-center">
                    <h6>Total Valid Opp</h6>
                    <h4>{{ getTotalStatus(meetings_details, 24) }}</h4>
                  </span>

                  <span class="card p-2 mb-2 text-center">
                    <h6>Total Canceled Opp</h6>
                    <h4>{{ getTotalStatus(meetings_details, 34) }}</h4>
                  </span>

                  <span class="card p-2 mb-2 text-center">
                    <h6>Total Absent Opp</h6>
                    <h4>{{ getTotalStatus(meetings_details, 35) }}</h4>
                  </span>

                  <template v-for="(item, label) in cardData">
                    <span class="card p-2 mb-2 text-center">
                      <h6>{{ $t("lang.column." + label) }}</h6>
                      <h4>{{ item[0].total }}</h4>
                    </span>
                  </template>
                </div>
              </div>
              <div class="col-md-9">
                <div class="row">
                  <div v-for="graph in graphsData" class="col-md-2">
                    <div class="p-2">
                      <doughnut-chart class="py-2" :chart-data="graph" :options="graph.options" :height="200" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <LoadingSpinner v-if="graphsDataLoading" />

          <div class="float-right">
            <FilterSystem class="float-right mr-2" :columns="filterColumns" :reset="resetFilterSystem" :sort="sort"
              :dir="dir" :filterSystem="filtersDash" :filterOldQuery="oldQuery" :key="filterkey"
              @callApi="filterNow($event)" />
          </div>
          <div class="table-container">
            <table class="table mt-2 ml-2">
              <thead>
                <tr>
                  <th>{{ $t("lang.column.client") }}</th>
                  <th>{{ $t("lang.column.campaign") }}</th>
                  <th>{{ $t("lang.column.creationdate") }}</th>
                  <th>{{ $t("lang.column.eventdate") }}</th>
                  <th>{{ $t("lang.column.status") }}</th>
                  <th>{{ $t("lang.column.opportunityStatus") }}</th>
                  <th>{{ $t("lang.label.businesses") }}</th>
                  <th>{{ $t("lang.column.prospect") }}</th>
                  <th>{{ $t("lang.column.prospect_referent") }}</th>
                  <th>{{ $t("lang.column.prospect_provider") }}</th>
                  <th>{{ $t("lang.column.business_size") }}</th>
                  <th>Logo</th>
                  <th>{{ $t("lang.column.business_category") }}</th>
                  <th>{{ $t("lang.column.linked_campaign") }}</th>
                  <th>{{ $t("lang.column.meetingPrice") }}</th>
                  <th>{{ $t("lang.column.financial_status") }}</th>
                </tr>
              </thead>
              <tr v-for="event in meetings_details" class="bg-light border-top">
                <td>{{ event.client_name }}</td>
                <td>
                  {{ event.name }}
                  <i class="icon-calendar text-primary cursor-pointer" v-if="calendlyid != event.remark"
                    @click="calendlyid = event.remark"></i>
                  <CalendlyEvent :id="event.remark" v-if="calendlyid == event.remark"></CalendlyEvent>
                </td>
                <td>
                  <!-- {{ getEventRow(event.event_date) }} -->
                  <p v-for="ev in getEventRow(event.event_date)">
                    {{ getEventDate(ev, 0) }}
                  </p>
                  <!-- <table>
                  <thead>
                    <tr>
                      <th>{{ $t("lang.column.creationdate") }}</th>
                      <th>{{ $t("lang.column.eventdate") }}</th>
                      <th>{{ $t("lang.column.status") }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-if="getEventRow(event.event_date)"
                      v-for="ev in getEventRow(event.event_date)"
                    >
                      <td>C {{ getEventDate(ev, 0) }}</td>
                      <td>E {{ getEventDate(ev, 1) }}</td>
                      <td>
                        <span
                          class="badge"
                          :class="getClassBadge(getEventDate(ev, 2))"
                          >{{ getEventDate(ev, 2) }}</span
                        >
                      </td>
                    </tr>
                  </tbody>
                </table> -->
                </td>
                <td>
                  <p v-for="ev in getEventRow(event.event_date)">
                    {{ getEventDate(ev, 1) }}
                  </p>
                </td>
                <td>
                  <p v-for="ev in getEventRow(event.event_date)">
                    <span class="badge" :class="getClassBadge(getEventDate(ev, 2))">{{ getEventDate(ev, 2) }}</span>
                  </p>
                </td>

                <td>
                  <strong v-if="event.status == null"><span class="badge bg-success text-white">valid</span></strong>
                  <strong v-if="event.status == 34"><span class="badge bg-danger text-white">canceled</span></strong>
                  <strong v-if="event.status == 24"><span class="badge bg-success text-white">valid</span></strong>
                  <strong v-if="event.status == 35"><span class="badge bg-warning text-white">absent</span></strong>
                </td>
                <td>
                  <strong><a class="text-primary ml-2 ml-2" target="_blank" :href="'/opportunities/' + event.link_id">{{
                      event.business_name }}</a></strong>
                </td>
                <td>
                  <p v-for="ev in getEventRow(event.event_date)">
                    {{ getEventDate(ev, 3) }}
                  </p>
                </td>
                <td>
                  <p v-for="ev in getEventRow(event.event_date)">
                    {{ getEventDate(ev, 4) }}
                  </p>
                </td>
                <td>
                  <p v-for="ev in getEventRow(event.event_date)">
                    {{ getEventDate(ev, 5) }}
                  </p>
                </td>
                <td>{{ event.business_size }}</td>
                <td>
                  <img :src="event.business_logo" alt="" class="rounded-circle img-buss" />
                </td>
                <td colspan="1">{{ event.business_category }}</td>
                <td>{{ event.linked }}</td>
                <td>
                  <p v-for="ev in getEventRow(event.event_date)">
                    {{ getEventDate(ev, 6) }}
                  </p>
                </td>
                <td>
                  <p v-for="ev in getEventRow(event.event_date)">
                    {{ getEventDate(ev, 7) }}
                  </p>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-2" v-if="currentUser.role_id !== '4' && tab == 2">
      <select v-model="client" class="form-control" @change="showNow(client)">
        <option v-for="team in groups" :value="team.id">{{ team.name }}</option>
      </select>
    </div>

    <div class="row" v-if="tab == 2 && showteam">
      <div class="col-12 " v-if="currentUser.role_id !== '4' && tab == 2"></div>
      <div class="card w-100 p-2 my-3">
        <TableMonitor filters:filtersDash :team_id="showteam" :key="showteam"></TableMonitor>
      </div>
    </div>
    <!-- <div class="row" v-else-if="tab == 2">
      <div class="card w-100 p-2 my-3">
        <TableMonitor :team_id="team_id" :key="showteam"></TableMonitor>
      </div>
    </div> -->

    <div v-for="(pos, key) in positions" v-if="pos.tab == tab">
      <div class="row mt-2">
        <Fieldset :title="pos.title" :mykey="key" :open="false">
          <div v-for="not in notif" v-if="showThisItem(pos, not)">
            <small class="text-secondary">{{ not.not_created }} </small>
            <small v-if="not.quantity == 1 && not.ref_id == 1" class="badge badge-secondary mr-1">{{ not.title }} ({{
              not.quantity }})</small>
            <small v-if="not.quantity == 2 && not.ref_id == 1" class="badge badge-warning mr-1">{{ not.title }} ({{
              not.quantity }})</small>
            <small v-if="not.quantity > 2 && not.ref_id == 1" class="badge badge-danger mr-1">{{ not.title }} ({{
              not.quantity }})</small>
            <small v-if="not.ref_id == 2" class="badge badge-success mr-1 text-white">
              {{ not.title }}</small>
            {{ not.message }}
          </div>
        </Fieldset>
      </div>
    </div>

    <div class="col-4" v-if="tab == 3">
      <h4>{{ getTittle() }}</h4>
    </div>
    <div class="row" v-if="tab == 3">
      <div v-if="workspace" class="col-md-3 my-2" v-for="(project, key) in workspace" :key="key">
        <div class="p-4 bg-light rounded text-center shadow">
          <h4><i class="icon-group"></i></h4>
          <div class="w-100">
            <span>{{ project.email_owner }} <br /><strong> </strong></span>
            <br />
            id:{{ project.id }}
            <br />
            <span>{{ project.project_id }}</span>
          </div>
          <button @click="openModal('workspace', project.id)" class="btn btn-sm btn-primary mt-3 mr-1">
            {{ $t("lang.button.domainList") }}
          </button>
          <!-- @click="openWorkspace(project)" -->
          <button class="btn btn-sm btn-secondary mt-3">
            {{ $t("lang.button.buyDomains") }}
          </button>
        </div>
      </div>

      <div class="col-md-3 my-2">
        <div class="p-4 bg-light rounded text-center shadow">
          <h4><i class="icon-group"></i></h4>
          <div class="w-100">
            <span>OUTLOOK <br /><strong> </strong></span>

            <br />
          </div>
          <button @click="openModal('workspace', '')" class="btn btn-sm btn-primary mt-3 mr-1">
            {{ $t("lang.button.domainList") }}
          </button>
          <!-- @click="openWorkspace('')" -->
          <button class="btn btn-sm btn-secondary mt-3">
            {{ $t("lang.button.buyDomains") }}
          </button>
        </div>
      </div>

      <div class="col-md-3 my-2">
        <div class="p-4 bg-light rounded text-center shadow">
          <h4><i class="icon-group"></i></h4>
          <div class="w-100">
            <span>ZAPMAIL GOOGLE <br /><strong> </strong></span>
            <!-- ZAPMAIL_ID -> 1 -->
            <br />
          </div>
          <button @click="openZapmailModal(1)" class="btn btn-sm btn-primary mt-3 mr-1">
            {{ $t("lang.button.domainList") }}
          </button>
          <!-- @click="openWorkspace('', true, 1)" -->
          <button @click="openWorkspace('', true, 1)" class="btn btn-sm btn-primary mt-3">
            {{ $t("lang.button.buyDomains") }}
          </button>
        </div>
      </div>

      <div class="col-md-3 my-2">
        <div class="p-4 bg-light rounded text-center shadow">
          <h4><i class="icon-group"></i></h4>
          <div class="w-100">
            <span>ZAPMAIL MICROSOFT  <br /><strong> </strong></span>
            <!-- ZAPMAIL_ID -> 2 -->
            <br />
          </div>
          <button @click="openZapmailModal(2)" class="btn btn-sm btn-primary mt-3 mr-1">
            {{ $t("lang.button.domainList") }}
          </button>
          <!-- @click="openWorkspace('', true, 2)" -->
          <button @click="openWorkspace('', true, 2)" class="btn btn-sm btn-primary mt-3">
            {{ $t("lang.button.buyDomains") }}
          </button>
        </div>
      </div>

    </div>
    <div class="row mt-4" v-if="tab == 3">
      <div class="col-md-3">
        <div @click="openModal('pending')" class="p-4 bg-light rounded text-center cursor-pointer shadow">
          <h4><i class="icon-clock"></i></h4>
          <p>{{ $t("lang.button.pendingDomains") }}</p>
        </div>
      </div>

      <div class="col-md-3">
        <div class="text-center p-2 card shadow bg-light" v-if="tab == 3">
          <div class="content">
            <p class="ml-2 mt-2 mb-2">
              {{ $t("lang.button.ActivesNylasAccounts") }}
            </p>
            <h3>{{ activenylas }}</h3>
          </div>
        </div>
      </div>
    </div>
    <div v-if="tab == 10">
      <div class="col-4">
        <h4>{{ getTittle() }}</h4>
      </div>
      <EmailQueueStats :groups="groups" />
    </div>
    <template v-if="tab == 18">
      <DomainList />
    </template>

    <!-- Tab Metric (21) Content  -->
    <template v-if="tab == 21">
      <Metrics :startDate="range.startDate" :endDate="range.endDate" :clientId="client ? client : '0'"
        :getDataMetrics="getDataMetrics" />
    </template>

    <!-- Operators -->
    <template v-if="tab == 24">
      <OperatorsAvgTime />
    </template>

    <!-- Phone Directory -->
    <template v-if="tab == 28">
      <PhoneDirectory />
    </template>

    <!-- Operators -->
    <template v-if="tab == 29">
      <RevenueClient />
    </template>


    <!-- modal para zapmail -->
    <modal
      name="zapmailmanageworkspace"
      :clickToClose="true"
      :resizable="true"
      :scrollwheel="true"
      height="400px"
      width="80%"
      class="p-3"
    >
      <ZapmailManageWorkspace :project="project" :zapmailid="zapmailid"></ZapmailManageWorkspace>
    </modal>


    <modal
      name="manageworkspace"
      :clickToClose="true"
      :resizable="true"
      :scrollwheel="true"
      height="400px"
      width="80%"
      class="p-3"
    >
      <ManageWorkspace :project="project"></ManageWorkspace>
    </modal>

    <Modal name="zapmail" height="400px" width="80%" class="p-3">
      <div class="text-center py-5" v-if="loadingWorkspace">
        <LoadingSpinner class="mx-auto" style="width: 150px; height: 150px;" />
        <p class="mt-3 text-muted">Loading workspaces...</p>
      </div>
      <div class="row" v-else>
        <div class="col-6 mb-3" v-for="(domain, key) in zapmailDomains" :key="key">
          <div class="d-inline ml-2">
            <span v-if="domain.https" class="d-inline text-success">
              <strong>HTTPS</strong><i class="icon-checkmark"></i>
            </span>
            <span v-else class="d-inline text-danger">
              <strong>HTTPS</strong><i class="icon-close"></i>
            </span>
          </div>

          <span v-if="domain.dkim == 'TXT'" class="d-inline ml-2 text-success">
            <strong>DKIM</strong><i class="icon-checkmark"></i>
          </span>
          <span v-if="domain.dkim == null" class="d-inline ml-2 text-danger">
            <strong>DKIM</strong><i class="icon-close"></i>
          </span>
          <Fieldset :title="domain.domain" :mykey="key" @opennow="openDomain(domain.workspace_domain_id)">
            {{ domain.name }}
            <div v-if="workspaceusers" v-for="domain in workspaceusers">
              <div class="card m-2 p-2 " @click="openModal('domain', domain.workspace_id)">
                <span> {{ domain.email }}</span>
              </div>
            </div>
          </Fieldset>
        </div>
      </div>
      <div class="col-12 text-center mt-5" v-if="zapmailDomains.length == 0">
        <p class="text-muted">No zapmail domains found</p>
      </div>
    </Modal>

    <modal name="workspace" :clickToClose="true" :resizable="true" :scrollwheel="true" height="400px" width="80%"
      class="p-3">
      <div class="text-center py-5" v-if="loadingWorkspace">
        <LoadingSpinner class="mx-auto" style="width: 150px; height: 150px;" />
        <p class="mt-3 text-muted">Loading workspaces...</p>
      </div>
      <div class="row" v-else>
        <div class="col-6 mb-3" v-for="(domain, key) in workspacedomains" :key="key">
          <div class="d-inline ml-2">
            <span v-if="domain.https" class="d-inline text-success">
              <strong>HTTPS</strong><i class="icon-checkmark"></i>
            </span>
            <span v-else class="d-inline text-danger">
              <strong>HTTPS</strong><i class="icon-close"></i>
            </span>
          </div>

          <span v-if="domain.dkim == 'TXT'" class="d-inline ml-2 text-success">
            <strong>DKIM</strong><i class="icon-checkmark"></i>
          </span>
          <span v-if="domain.dkim == null" class="d-inline ml-2 text-danger">
            <strong>DKIM</strong><i class="icon-close"></i>
          </span>
          <Fieldset :title="domain.domain" :mykey="key" @opennow="openDomain(domain.workspace_domain_id)">
            {{ domain.name }}
            <div v-if="workspaceusers" v-for="domain in workspaceusers">
              <div class="card m-2 p-2 " @click="openModal('domain', domain.workspace_id)">
                <span> {{ domain.email }}</span>
              </div>
            </div>
          </Fieldset>
        </div>
        <div class="col-12 text-center mt-5" v-if="workspacedomains.length == 0">
          <p class="text-muted">No workspaces found</p>
        </div>
      </div>
    </modal>

    <modal name="pending" :clickToClose="true" :resizable="true" :scrollwheel="true" height="auto" width="80%"
      class="p-3">
      <div class="row" v-if="pendingdomains">
        <div class="col-2" v-for="(domain, key) in pendingdomains" :key="key">
          <div class="card m-2 p-2 shadow" @click="openModal('domain', domain.id)">
            <span>
              {{ domain.domain }} <strong>({{ domain.name }})</strong></span>
          </div>
        </div>
      </div>
    </modal>

    <div>
      <!-- TAB 8 -->
      <div class="col-md-12" v-if="tab == 8"></div>
      <div class="card no-border mt-3" v-if="tab == 8 && openlist">
        <template v-if="!graphsDataLoading">
          <div class="row">
            <div class="col-md-3">
              <div class="p-3">
                <span class="card p-2 mb-2 text-center">
                  <h6>Total Opp</h6>
                  <h4>{{ meetings_details.length }}</h4>
                </span>

                <span class="card p-2 mb-2 text-center">
                  <h6>Total Valid Opp</h6>
                  <h4>{{ getTotalStatus(meetings_details, 24) }}</h4>
                </span>

                <span class="card p-2 mb-2 text-center">
                  <h6>Total Canceled Opp</h6>
                  <h4>{{ getTotalStatus(meetings_details, 34) }}</h4>
                </span>

                <span class="card p-2 mb-2 text-center">
                  <h6>Total Absent Opp</h6>
                  <h4>{{ getTotalStatus(meetings_details, 35) }}</h4>
                </span>

                <template v-for="item in cardData">
                  <span class="card p-2 mb-2 text-center">
                    <h6>{{ $t("lang.column." + item[0].label) }}</h6>
                    <h4>{{ item[0].total }}</h4>
                  </span>
                </template>
              </div>
            </div>
            <div class="col-md-9">
              <div class="row">
                <div v-for="graph in graphsData" class="col-md-2">
                  <div class="p-2">
                    <doughnut-chart class="py-2" :chart-data="graph" :options="graph.options" :height="200" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <LoadingSpinner v-if="graphsDataLoading" />

        <div class="my-4 table-container table-responsive" style="height: 600px">
          <table class="table mt-2 ml-2">
            <thead>
              <tr>
                <th>{{ $t("lang.column.client") }}</th>
                <th>{{ $t("lang.label.order") }}</th>
                <th>{{ $t("lang.column.creationdate") }}</th>
                <th>{{ $t("lang.column.eventdate") }}</th>
                <th>{{ $t("lang.column.status") }}</th>
                <th>{{ $t("lang.column.opportunityStatus") }}</th>
                <th>{{ $t("lang.label.businesses") }}</th>
                <th>{{ $t("lang.column.prospect") }}</th>
                <th>{{ $t("lang.column.prospect_referent") }}</th>
                <th>{{ $t("lang.column.prospect_provider") }}</th>
                <th>{{ $t("lang.column.business_size") }}</th>
                <th>Logo</th>
                <th>{{ $t("lang.column.business_category") }}</th>
                <th>{{ $t("lang.column.linked_campaign") }}</th>
                <th>{{ $t("lang.column.meetingPrice") }}</th>
                <th>{{ $t("lang.column.financial_status") }}</th>
              </tr>
            </thead>
            <tr v-for="event in meetings_details" class="bg-light border-top">
              <td><span class="text-primary cursor-pointer" @click="goToClient(event.client_id)">{{ event.client_name }}</span></td>
              <td>
                <span class="text-primary cursor-pointer" @click="goToOrder(event.target_id)">{{ event.name }}</span> 
                <i class="icon-calendar text-primary cursor-pointer pl-2" v-if="calendlyid != event.remark"
                  @click="calendlyid = event.remark"></i>
                <CalendlyEvent :id="event.remark" v-if="calendlyid == event.remark"></CalendlyEvent>
              </td>
              <td>
                <!-- {{ getEventRow(event.event_date) }} -->
                <p v-for="ev in getEventRow(event.event_date)">
                  {{ getEventDate(ev, 0) }}
                </p>
                <!-- <table>
                  <thead>
                    <tr>
                      <th>{{ $t("lang.column.creationdate") }}</th>
                      <th>{{ $t("lang.column.eventdate") }}</th>
                      <th>{{ $t("lang.column.status") }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-if="getEventRow(event.event_date)"
                      v-for="ev in getEventRow(event.event_date)"
                    >
                      <td>C {{ getEventDate(ev, 0) }}</td>
                      <td>E {{ getEventDate(ev, 1) }}</td>
                      <td>
                        <span
                          class="badge"
                          :class="getClassBadge(getEventDate(ev, 2))"
                          >{{ getEventDate(ev, 2) }}</span
                        >
                      </td>
                    </tr>
                  </tbody>
                </table> -->
              </td>
              <td>
                <p v-for="ev in getEventRow(event.event_date)">
                  {{ getEventDate(ev, 1) }}
                </p>
              </td>
              <td>
                <p v-for="ev in getEventRow(event.event_date)">
                  <span class="badge" :class="getClassBadge(getEventDate(ev, 2))">{{ getEventDate(ev, 2) }}</span>
                </p>
              </td>

              <td>
                <strong v-if="event.status == null"><span class="badge bg-success text-white">valid</span></strong>
                <strong v-if="event.status == 34"><span class="badge bg-danger text-white">canceled</span></strong>
                <strong v-if="event.status == 24"><span class="badge bg-success text-white">valid</span></strong>
                <strong v-if="event.status == 35"><span class="badge bg-warning text-white">absent</span></strong>
              </td>
              <td>
                <strong><a class="text-primary ml-2 ml-2" target="_blank" :href="'/opportunities/' + event.link_id">{{
                  event.business_name }}</a></strong>
              </td>
              <td>
                <p v-for="ev in getEventRow(event.event_date)">
                  {{ getEventDate(ev, 3) }}
                </p>
              </td>
              <td>
                <p v-for="ev in getEventRow(event.event_date)">
                  {{ getEventDate(ev, 4) }}
                </p>
              </td>
              <td>
                <p v-for="ev in getEventRow(event.event_date)">
                  {{ getEventDate(ev, 5) }}
                </p>
              </td>
              <td>{{ event.business_size }}</td>
              <td>
                <img :src="event.business_logo" alt="" class="rounded-circle img-buss" />
              </td>
              <td colspan="1">{{ event.business_category }}</td>
              <td>{{ event.linked }}</td>
              <td>
                <p v-for="ev in getEventRow(event.event_date)">
                  {{ getEventDate(ev, 6) }}
                </p>
              </td>
              <td>
                <p v-for="ev in getEventRow(event.event_date)">
                  {{ getEventDate(ev, 7) }}
                </p>
              </td>
            </tr>
          </table>
        </div>

        <!-- <table class="mt-2 ml-2">
          <thead>
            <tr>
              <td>{{ $t("lang.column.client") }}</td>
              <td>{{ $t("lang.column.campaign") }}</td>
              <td>{{ $t("lang.column.eventdate") }}</td>
              <td>{{ $t("lang.column.opportunityStatus") }}</td>
              <td>{{ $t("lang.label.businesses") }}</td>
            </tr>
          </thead>
          <tr v-for="event in meetings_details" class="bg-light border-top">
            <td>{{ event.client_name }}</td>
            <td>
              {{ event.name }}
              <i
                class="icon-calendar text-primary cursor-pointer"
                v-if="calendlyid != event.remark"
                @click="calendlyid = event.remark"
              ></i>
              <CalendlyEvent
                :id="event.remark"
                v-if="calendlyid == event.remark"
              ></CalendlyEvent>
            </td>
            <td>
              <table>
                <thead>
                  <tr>
                    <th>{{ $t("lang.column.creationdate") }}</th>
                    <th>{{ $t("lang.column.eventdate") }}</th>
                    <th>{{ $t("lang.column.status") }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-if="getEventRow(event.event_date)"
                    v-for="ev in getEventRow(event.event_date)"
                  >
                    <td>C {{ getEventDate(ev, 0) }}</td>
                    <td>E {{ getEventDate(ev, 1) }}</td>
                    <td>
                      <span
                        class="badge"
                        :class="getClassBadge(getEventDate(ev, 2))"
                        >{{ getEventDate(ev, 2) }}</span
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
            <td>
              <strong v-if="event.status == null"
                ><span class="badge bg-success text-white">valid</span></strong
              >
              <strong v-if="event.status == 34"
                ><span class="badge bg-danger text-white"
                  >canceled</span
                ></strong
              >
              <strong v-if="event.status == 24"
                ><span class="badge bg-success text-white">valid</span></strong
              >
              <strong v-if="event.status == 35"
                ><span class="badge bg-warning text-white">absent</span></strong
              >
            </td>
            <td>
              <strong
                ><a
                  class="text-primary ml-2 ml-2"
                  target="_blank"
                  :href="'/opportunities/' + event.link_id"
                  >{{ event.business_name }}</a
                ></strong
              >
            </td>
          </tr>
        </table>
      </div>
    </div> -->
        <!-- FIN TAB 8 -->

        <div class="row" v-if="false">
          <div class="col-md-6">
            <h3>Active Campaigns</h3>
            <div class="scrollable">
              <div class="row m-2 border" v-for="(campaign, key) in activecampaigns">
                <div class="col-6">
                  <li>Campaign Name: {{ campaign.name }}</li>
                  <li>Client: {{ campaign.clientname }}</li>
                </div>
                <div class="col-6"></div>
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <h3>Last Users</h3>
            <div class="card scrollable">
              <Table v-if="lastusers.length > 0" :key="keytable" :headers="headers" :cols="cols" :data="lastusers"
                :checkbox="false" :model="model">
              </Table>
            </div>
          </div>

          <div class="col-md-12 mt-3">
            <h3>Gmaps Imports</h3>
            <button class="btn btn-sm btn-primary" @click="refreshgmail()">
              <i class="icon-refresh"></i>
            </button>
            <div class="card scrollable p-2">
              <Table v-if="gmaillist.length > 0 && !loadinggmail" :key="keygmail" :headers="headers3" :cols="cols3"
                :data="gmaillist" :checkbox="false" :model="model">
              </Table>
              <span v-if="loadinggmail" class="loadingres mr-2 ml-2 spinner-border loading-spinner"></span>
            </div>
          </div>

          <div class="col-md-12 mt-3">
            <h3>Linkedin Imports</h3>
            <button class="btn btn-sm btn-primary" @click="refreshlinkedin()">
              <i class="icon-refresh"></i>
            </button>
            <div class="card scrollable p-2">
              <Table v-if="linkedinlist.length > 0 && !loadinglinkedin" :key="keygmail" :headers="headers4"
                :cols="cols4" :data="linkedinlist" :checkbox="false" :model="model">
              </Table>
              <span v-if="loadinglinkedin" class="loadingres mr-2 ml-2 spinner-border loading-spinner"></span>
            </div>
          </div>
        </div>
      </div>

      <!-- Tab Meeting dispertion / Tab = 22 -->
      <div class="my-4 table-container table-responsive" style="height: 100vh" v-if="tab == 22">
        <LoadingSpinner v-if="getDataLoading" />
        <div v-else>
          <table class="table mt-2 ml-2">
            <thead class="bg-light">
              <tr>
                <th>{{ $t("lang.column.client") }}</th>
                <th>Client Status</th>
                <th>Conversion rate</th>
                <th>Total meetings</th>
                <th>Meeting impact</th>
                <th>CA HT</th>
                <th>CA Impact</th>
                <th>Manual Answer Rate</th>
                <th>Sent</th>
                <th>New Prospects</th>
                <th>New Prospects First Sent %</th>
                <th>AVG Touchpoint</th>
              </tr>
            </thead>
            <tr v-for="(client, index) in meetings_details_by_client" class="bg-light border-top" :key="index">
              <td class="text-primary cursor-pointer" @click="goToClient(client.id)">{{ client.client_name }}</td>
              <td>
                <span v-if="client.client_status">
                  {{ client.client_status }}
                </span>
              </td>
              <td>{{ client.conversion_rate }}%</td>
              <td>
                {{ client.total_meetings_by_client }}
              </td>
              <td>{{ client.meeting_impact }}%</td>
              <td>
                <span v-if="client.money_by_client">
                  {{ client.money_by_client }} <span class="ml-1">€</span>
                </span>
              </td>
              <td>
                <span v-if="client.ca_impact"> {{ client.ca_impact }}% </span>
              </td>
              <td>
                <span v-if="client.response_rate">
                  {{ parseFloat(client.response_rate).toFixed(2) }} %
                </span>
              </td>
              <td>
                <span v-if="client.total_sent">
                  {{ client.total_sent }}
                </span>
              </td>
              <td>
                <span v-if="client.total_newprospects">
                  {{ client.total_newprospects }}
                </span>
              </td>
              <td>
                <span v-if="client.newprospects_first_sent">
                  {{ parseFloat(client.newprospects_first_sent).toFixed(2) }}
                </span>
              </td>
              <td>
                <span v-if="client.total_touchpoint_avg">
                  {{ parseFloat(client.total_touchpoint_avg).toFixed(2) }}
                </span>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  statusBadgeMixin,
  statusPointMixin,
  statusFeedNotificationsMixin,
  formattersMixin,
} from "@/_mixins/";
import Table from "@/components/Common/Table.vue";
import TabItem from "@/components/Common/TabItem.vue";
import AccountEmailList from "@/components/Emails/AccountEmailList.vue";
import BusinessContactEmailList from "@/components/Emails/BusinessContactEmail.vue";
import TableMonitor from "@/components/Dashboard/Monitor/Table.vue";
import ManageWorkspace from "@/components/Workspace/ManageWorkspace.vue";
import ZapmailManageWorkspace from "@/components/Workspace/ZapmailManageWorkspace.vue";
import ContactsAvailable from "@/components/Campaigns/ContactsAvailable.vue";
import CalendlyEvent from "@/components/Common/CalendlyEvent.vue";
import Fieldset from "@/components/Common/Fieldset.vue";
import Checkhttps from "@/components/Common/Checkhttps.vue";
import { mapState, mapActions } from "vuex";
import { router } from "@/_helpers";
import moment from "moment";
import LineChart from "@/components/Chart.vue";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { ASYNC_SEARCH } from "@riophae/vue-treeselect";
const simulateAsyncOperation = (fn) => {
  setTimeout(fn, 2);
};
import FilterSystem from "@/components/FilterSystem.vue";
import Tutorial from "@/components/Tutorial.vue";
import DoughnutChart from "@/components/DoughnutChart.vue";
import {
  adminService,
  monitorService,
  campaignsService,
  workspaceService,
  usersService,
} from "@/_services";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import DashboardStatistics from "@/components/Campaigns/DashboardStatistics.vue";
import EmailSyncList from "@/components/Agencies/EmailSyncList.vue";
import EmailQueueStats from "@/components/EmailQueue/EmailQueueStats.vue";
import DomainList from "@/components/Dashboard/DomainList.vue";
import Metrics from "@/components/Dashboard/Metrics.vue";
import AllEmails from "../Emails/AllEmails.vue";
import DashboardReportCredit from "@/components/Dashboard/DashboardReportCredit.vue";
import OperatorsAvgTime from "@/components/Reports/OperatorsAvgTime.vue";
import RevenueClient from "@/components/Reports/RevenueClient.vue";
import BookerCallUnreachable from "@/components/BDR/BookerCallUnreachable.vue";
import PhoneDirectory from "@/components/BDR/PhoneDirectory.vue";

export default {
  props: {
    clientId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      zapmailid: null,
      langs: [],
      warmupActiveOptions: [
        { id: 1, label: this.$t("lang.button.yes") },
        { id: 0, label: this.$t("lang.label.no") },
      ],
      type_stats: "",
      getDataMetrics: false,
      getDataLoading: false,
      graphsDataLoading: true,
      graphsData: [],
      cardData: {},
      filterColumns: [
        {
          name: this.$t("lang.column.prospect_provider"),
          name_: "email",
          type: "string",
          field: "ce.provider_email",
        },
        {
          name: this.$t("lang.column.prospect_referent"),
          name_: "Référent",
          type: "list",
          list: [
            { id: false, name: this.$t("lang.button.yes") },
            { id: true, name: this.$t("lang.label.no") },
          ],
          field: "bc.id",
        },
        {
          name: this.$t("lang.column.status"),
          name_: "status",
          type: "list",
          list: [
            {
              id: "active",
              name: "Active",
            },
            {
              id: "canceled",
              name: "Canceled",
            },
          ],
          field: "le.status",
        },
        {
          name: this.$t("lang.column.opportunityStatus"),
          name_: "status_opor",
          type: "list",
          list: [
            {
              id: "24",
              name: "Active",
            },
            {
              id: "34",
              name: "Canceled",
            },
            {
              id: "35",
              name: "Absent",
            },
          ],
          field: "l.link_status_reason_id",
        },
        {
          name: "Entreprises",
          name_: "entreprises",
          type: "string",
          field: "client.name",
        },
        {
          name: "Email",
          name_: "email",
          having: true,
          type: "string",
          field: "email_p",
        },
        {
          name: this.$t("lang.label.creationdate"),
          type: "date",
          having: true,
          field: "le_creation_date",
        },
        {
          name: this.$t("lang.column.eventdate"),
          type: "date",
          having: true,
          field: "le_event_date",
        },
        {
          name: "LIE",
          name_: "LIE",
          type: "list",
          list: [
            { id: true, name: "yes" },
            { id: false, name: "no" },
          ],
          field: "l.campaign_id",
        },
        {
          name: "Industrie du prospect",
          name_: "name",
          type: "string",
          field: "cg.name_fr",
        },
        {
          name: "Taille du prospect",
          name_: "name",
          type: "number",
          field: "b.salaries",
        },
      ],
      project: {},
      filtersDash: {},
      openrappellist: false,
      activenylas: [],
      showteam: false,
      workspace: false,
      workspacedomains: false,
      zapmailDomains: false,
      workspaceusers: false,
      pendingdomains: false,
      positions: [
        {
          title: "Gmail Workspace",
          tab: 4,
          type: "workspace",
        },
        {
          title: "Gmail Workspace",
          tab: 5,
          type: "workspacecom",
        },
        {
          title: "Campaigns",
          tab: 4,
          type: "campaigns",
        },
        {
          title: "Campaigns",
          tab: 5,
          type: "campaignsupporterror",
        },
        {
          title: "Workflows",
          tab: 4,
          type: "workflows",
        },
        {
          title: "Payments",
          tab: 6,
          type: "payments",
        },
        {
          title: "Contracts",
          tab: 6,
          type: "contracts",
        },
      ],
      notif: [],
      rappellist: [],
      googleusers: [],
      absentLinks: [],
      sort: "",
      dir: "",
      oldQuery: "",
      resetFilterSystem: false,
      filterkey: 3444,
      openlist: false,
      totalkey: 0,
      client: false,
      clients: [],
      showAdvancedFilters: false,
      defaulOptions: [],
      filters: {
        type: [],
        sendingIps: [],
        sendingMethods: [],
        sendingProviders: [],
        clientSignedOn: {
          startDate: null,
          endDate: null,
        },
        launchDate: {
          startDate: null,
          endDate: null,
        },
        orderLanguage: [],
      },
      // filters2: [],
      // filters3: [],
      value: null,
      optselect: [],
      sendingIps: [],
      sendingMethods: [
        {
          id: "1",
          label: "API Nylas",
          role: ["1", "5", "6"],
          isDisabled: false,
          color: "255,0,100",
        },
        {
          id: "3",
          label: "API Oliverlist",
          role: ["1", "5", "6"],
          isDisabled: false,
          color: "255,0,100",
        },
        {
          id: "2",
          label: "SMTP ",
          role: ["1", "5", "6"],
          isDisabled: false,
          color: "255,0,100",
        },
      ],
      sendingProviders: [
        {
          id: "ews",
          label: "Outlook",
          role: ["1", "5", "6"],
          isDisabled: false,
          color: "255,0,100",
        },
        {
          id: "gmail",
          label: "Gmail",
          role: ["1", "5", "6"],
          isDisabled: false,
          color: "255,0,100",
        },
      ],
      options: [
        {
          id: "validated_orders",
          label: "Validated orders ",
          role: ["1"],
          isDisabled: false,
          isRate: true,
          color: "43, 199, 0",
          format: "float",
        },
        {
          id: "sent",
          label: "Sent",
          role: ["1", "5", "6"],
          isDisabled: false,
          color: "255,79,118",
        },
        {
          id: "bounce_total",
          label: "Bounces",
          role: ["1", "5", "6"],
          isDisabled: false,
          color: "220,0,4",
        },
        {
          id: "bounce_prc",
          label: "Bounces %",
          role: ["1", "5", "6"],
          isDisabled: false,
          color: "220,120,44",
        },
        {
          id: "scheduled",
          label: "Scheduled",
          role: ["1", "5", "6"],
          isDisabled: false,
          color: "255,222,33",
        },
        {
          id: "new_teams",
          label: "New Teams",
          role: ["1", "5", "6"],
          isDisabled: false,
          color: "220,0,4",
        },
        {
          id: "new_contact_mobile",
          label: "New Contact Mobile",
          role: ["1", "5", "6"],
          isDisabled: false,
          color: "220,0,4",
        },
        {
          id: "lost_meeting_rate_cold",
          label: "Lost Meeting Rate Cold %",
          role: ["1", "5", "6"],
          isDisabled: false,
          color: "220,0,4",
        },
        {
          id: "new_contact_email",
          label: "New Contact Email",
          role: ["1", "5", "6"],
          isDisabled: false,
          color: "220,0,4",
        },
        {
          id: "booker_call_test",
          label: "Booker Call test",
          role: ["1", "5", "6"],
          isDisabled: false,
          color: "220,0,4",
        },
        {
          id: "projsend",
          label: "Projection sending",
          role: ["1"],
          isDisabled: false,
          color: "255,79,118",
        },
        {
          id: "projsend_new",
          label: "Projection sending new",
          role: ["1"],
          isDisabled: false,
          color: "151, 41, 134",
        },
        {
          id: "projsend_recurring",
          label: "Projection sending recurring",
          role: ["1"],
          isDisabled: false,
          color: "234, 0, 0",
        },
        {
          id: "projsend_recurring2",
          label: "Proj Step 2",
          role: ["1"],
          isDisabled: false,
          color: "255, 191, 191",
        },
        {
          id: "projsend_recurring3",
          label: "Proj Step 3",
          role: ["1"],
          isDisabled: false,
          color: "255, 149, 149",
        },
        {
          id: "projsend_recurring4",
          label: "Proj Step 4",
          role: ["1"],
          isDisabled: false,
          color: "255, 106, 106",
        },
        {
          id: "projsend_recurring5",
          label: "Proj Step 5",
          role: ["1"],
          isDisabled: false,
          color: "255, 64, 64",
        },
        {
          id: "projsend_recurring6",
          label: "Proj Step 6",
          role: ["1"],
          isDisabled: false,
          color: "255, 21, 21",
        },
        {
          id: "projsend_meetings",
          label: "Proj meetings",
          role: ["1"],
          isDisabled: false,
          isRate: false,
          color: "51, 204, 204",
        },
        {
          id: "projsend_money",
          label: "Proj CA TTC",
          role: ["1"],
          isDisabled: false,
          color: "43, 199, 0",
          format: "float",
        },        
        {
          id: "number_of_calls",
          label: "Number of calls",
          role: ["1"],
          isDisabled: false,
          color: "255, 64, 64",
        },
        {
          id: "number_of_calls_picked_up",
          label: "Number of calls - Picked Up",
          role: ["1"],
          isDisabled: false,
          isRate: true,
          color: "255, 21, 21",
        },
        {
          id: "per_of_calls_picked_up",
          label: "% of calls - Picked Up",
          role: ["1"],
          isDisabled: false,
          isRate: true,
          color: "51, 204, 204",
          format: "float",
        },
        {
          id: "meeting_rate_calls",
          label: "Meeting rate - Calls",
          role: ["1"],
          isDisabled: false,
          isRate: true,
          color: "43, 199, 0",
          format: "float",
        },
        // {
        //   id: "newsent",
        //   label: "New Sent",
        //   role: ["1", "5", "6"],
        //   isDisabled: false,
        //   color: "151, 41, 134",
        // },
        {
          id: "newprospects",
          label: "New Prospects",
          role: ["1", "5", "6"],
          isDisabled: false,
          color: "223, 138, 211",
        },
        {
          id: "newprospects_first",
          label: "New Prospects (first time)",
          role: ["1", "5", "6"],
          isDisabled: false,
          color: "43, 199, 0",
        },
        {
          id: "newprospects_first_prctg",
          label: "New Prospects (first time) %",
          role: ["1", "5", "6"],
          isDisabled: false,
          color: "28, 4, 219",
          isRate: true,
          format: "float",
        },
        {
          id: "recurringsent",
          label: "Recurring Sent",
          role: ["1", "5", "6"],
          isDisabled: false,
          color: "234, 0, 0",
        },
        {
          id: "recurringsent2",
          label: "Step 2",
          role: ["1"],
          isDisabled: false,
          color: "255, 191, 191",
        },
        {
          id: "recurringsent3",
          label: "Step 3",
          role: ["1"],
          isDisabled: false,
          color: "255, 149, 149",
        },
        {
          id: "recurringsent4",
          label: "Step 4",
          role: ["1"],
          isDisabled: false,
          color: "255, 106, 106",
        },
        {
          id: "recurringsent5",
          label: "Step 5",
          role: ["1"],
          isDisabled: false,
          color: "255, 64, 64",
        },
        {
          id: "recurringsent6",
          label: "Step 6",
          role: ["1"],
          isDisabled: false,
          color: "255, 21, 21",
        },
        {
          id: "money_meetings_without_tax",
          label: "AVG Meeting Price",
          role: ["1"],
          isDisabled: false,
          isRate: true,
          color: "43, 199, 0",
          format: "float",
        },
        {
          id: "money",
          label: "Revenue (incl tax)",
          role: ["1"],
          isDisabled: false,
          color: "43, 199, 0",
          format: "float",
        },
        {
          id: "money_without_tax",
          label: "Revenue",
          role: ["1"],
          isDisabled: false,
          color: "43, 199, 0",
          format: "float",
        },
        {
          id: "billing",
          label: "Invoiced Revenue",
          role: ["1", "5", "6", "7"],
          isDisabled: false,
          color: "28, 4, 219",
          format: "float",
        },
        {
          id: "meetings",
          label: this.$t("lang.statistics.generated"),
          role: ["4", "1", "5", "6", "7"],
          isDisabled: false,
          isRate: false,
          color: "51, 204, 204",
        },
        {
          id: "cancel_meetings_rate",
          label: "Cancel Meetings Rate",
          role: ["1"],
          isDisabled: false,
          color: "43, 199, 0",
          isRate: true,
          format: "float",
        },
        {
          id: "cashed",
          label: "Cashed out meetings",
          role: ["1"],
          isDisabled: false,
          color: "122, 169, 81",
        },
        {
          id: "sessions",
          label: this.$t("lang.statistics.session"),
          role: ["1"],
          isDisabled: false,
          color: "45, 138, 131",
        },
        {
          id: "response_rate",
          label: "MAR (Manual Answer Rate)",
          role: ["1", "5", "6"],
          isDisabled: false,
          color: "255,100,0",
          isRate: true,
          format: "float",
        },
        {
          id: "conversion_rate",
          label: "Converstion rate",
          role: ["1", "5", "6"],
          isDisabled: false,
          color: "255,100,0",
          isRate: true,
          format: "float",
        },
        {
          id: "new_bookers",
          label: "New Bookers",
          role: ["1", "5", "6"],
          isDisabled: false,
          color: "255,100,0",
          isRate: false,
        },
        {
          id: "booker_meetings_prc",
          label: "Booker impact %",
          role: ["1", "5", "6"],
          isDisabled: false,
          color: "255,100,0",
          isRate: true,
          format: "float",
        },
        {
          id: "domains_age",
          label: "Domains age",
          role: ["1", "5", "6"],
          isDisabled: false,
          color: "255,100,0",
          isRate: false,
          format: "float",
        },
        {
          id: "active_bookers",
          label: "Active Bookers",
          role: ["1", "5", "6"],
          isDisabled: false,
          color: "255,100,0",
          isRate: false,
          format: "float",
          type: "line",
        },
            {
          id: "bookers_verified_calls",
          label: "Bookers Verified Calls",
          role: ["1", "5", "6"],
          isDisabled: false,
          color: "43, 199, 0",
          isRate: false,
          format: "float",
        },
        // {
        //   id: "bookers_video_interviews",
        //   label: "Interviewed bookers",
        //   role: ["1", "5", "6"],
        //   isDisabled: false,
        //   color: "0, 150, 255",
        //   isRate: false,
        //   format: "float",
        // },
        {
          id: "bookers_verified_answers",
          label: "Bookers Verified Answers",
          role: ["1", "5", "6"],
          isDisabled: false,
          color: "45, 138, 131",
          isRate: false,
          format: "float",
        },
           {
          id: "bookers_meeting_rate_ubs_5",
          label: "Booker level 2 meeting rate",
          role: ["1", "5", "6"],
          isDisabled: false,
          color: "255,100,0",
            isRate: true,
          format: "float",
        },
        {
          id: "bookers_meeting_rate_ubs_6",
          label: "Booker manager meeting rate",
          role: ["1", "5", "6"],
          isDisabled: false,
          color: "255,100,200",
            isRate: true,
          format: "float",
        },
        {
          id: "calendar_click_rate",
          label: "Calendar click rate",
          role: ["1", "5", "6"],
          isDisabled: false,
          color: "255,100,0",
          isRate: false,
          format: "float",
        },
        {
          id: "canceled_meetings_verification",
          label: "Canceled Meetings Verification",
          role: ["1", "5", "6"],
          isDisabled: false,
          color: "255,100,0",
          isRate: true,
          format: "float",
        },
        // {
        //   id: "variance",
        //   label: "Standard Deviation",
        //   role: ["1", "5", "6"],
        //   isDisabled: false,
        //   color: "0,0,0",
        //   isRate: true,
        //   format: "float",
        // },
        // {
        //   id: "spam_rate",
        //   label: "Spam rate",
        //   role: ["1", "5", "6"],
        //   isDisabled: false,
        //   color: "255,100,0",
        //   isRate: true,
        //   format: "float",
        // },
        // {
        //   id: "warmy_deliverability",
        //   label: "Warmy Deliverability",
        //   role: ["1", "5", "6"],
        //   isDisabled: false,
        //   color: "204, 236, 44",
        //   isRate: true,
        //   format: "float",
        // },
        // {
        //   id: "warmy_score",
        //   label: "Warmy Score",
        //   role: ["1", "5", "6"],
        //   isDisabled: false,
        //   color: "13, 157, 217",
        //   isRate: true,
        //   format: "float",
        // },
        // {
        //   id: "placement_score",
        //   label: "Warmy ISP Score",
        //   role: ["1", "5", "6"],
        //   isDisabled: false,
        //   color: "204, 236, 44",
        //   isRate: true,
        //   format: "float",
        // },
        // {
        //   id: "deliverability",
        //   label: "Deliverability",
        //   role: ["1", "5", "6"],
        //   isDisabled: false,
        //   color: "204, 236, 44",
        //   isRate: true,
        //   format: "float",
        // },
        {
          id: "contactsintarget",
          label: "Contacts Added into targets",
          role: ["1"],
          isDisabled: false,
          color: "204, 106, 44",
          isRate: true,
          format: "float",
        },
        // {
        //   id: "enrich_success",
        //   label: "Business Contact - Enrich Success",
        //   role: ["1"],
        //   isDisabled: false,
        //   color: "188, 3, 153",
        //   isRate: true,
        //   format: "float",
        // },
        // {
        //   id: "import_success",
        //   label: "Apollo Import Success",
        //   role: ["1"],
        //   isDisabled: false,
        //   color: "1, 32, 4",
        //   isRate: true,
        //   format: "float",
        // },
        // {
        //   id: "import_new",
        //   label: "Apollo Import New Contacts",
        //   role: ["1"],
        //   isDisabled: false,
        //   color: "2, 1, 104",
        //   isRate: true,
        //   format: "float",
        // },
        // {
        //   id: "import_attempts",
        //   label: "Apollo import attempts",
        //   role: ["1"],
        //   isDisabled: false,
        //   color: "234, 69, 120",
        //   isRate: true,
        //   format: "float",
        // },
        {
          id: "meeting_qty",
          label: "Meetings Full",
          role: ["1", "5", "6"],
          isDisabled: false,
          color: "51, 204, 204",
        },
        // {
        //   id: "charged_rate",
        //   label: "Charged rate",
        //   role: ["1", "5", "6"],
        //   isDisabled: false,
        //   color: "23, 165, 137",
        //   isRate: true,
        //   format: "float",
        // },
        {
          id: "planned_qty",
          label: "Planned Qty",
          role: ["1", "5", "6"],
          isDisabled: false,
          color: "133, 193, 233",
        },
        {
          id: "charged_qty",
          label: "Charged Qty",
          role: ["1", "5", "6"],
          isDisabled: false,
          color: "23, 165, 137",
        },
        // {
        //   id: "uncharged_rate",
        //   label: "Uncharged rate",
        //   role: ["1", "5", "6"],
        //   isDisabled: false,
        //   color: "247, 220, 111",
        //   isRate: true,
        //   format: "float",
        // },
        {
          id: "uncharged_qty",
          label: "Uncharged Qty",
          role: ["1", "5", "6"],
          isDisabled: false,
          color: "247, 220, 111",
        },
        {
          id: "declined_rate",
          label: "Declined rate",
          role: ["1", "5", "6"],
          isDisabled: false,
          color: "241, 148, 138",
          isRate: true,
          format: "float",
        },
        {
          id: "declined_qty",
          label: "Declined Qty",
          role: ["1", "5", "6"],
          isDisabled: false,
          color: "241, 148, 138",
        },
        {
          id: "cancel_rate",
          label: "Cancel rate",
          role: ["1", "5", "6"],
          isDisabled: false,
          color: "187, 143, 206",
          isRate: true,
          format: "float",
        },
        {
          id: "cancel_qty",
          label: "Cancel Qty",
          role: ["1", "5", "6"],
          isDisabled: false,
          color: "187, 143, 206",
        },
        {
          id: "absent_rate",
          label: "Absent rate",
          role: ["1", "5", "6"],
          isDisabled: false,
          color: "133, 146, 158",
          isRate: true,
          format: "float",
        },
        {
          id: "absent_qty",
          label: "Absent Qty",
          role: ["1", "5", "6"],
          isDisabled: false,
          color: "133, 146, 158",
        },
        {
          id: "manual_tagged_er",
          label: "Manual tagged responses",
          role: ["1", "5", "6"],
          isDisabled: false,
          color: "205,50,0",
        },
        {
          id: "manual_tagged_er_prctg",
          label: "Manual tagged responses %",
          role: ["1", "5", "6"],
          isDisabled: false,
          color: "105,250,20",
          isRate: true,
          format: "float",
        },
        {
          id: "accounts_sent",
          label: "Accounts sent",
          role: ["1", "5", "6"],
          isDisabled: false,
          color: "105,200,0",
        },
        {
          id: "active_clients",
          label: "Active Clients",
          role: ["1", "5", "6"],
          isDisabled: false,
          color: "105,200,0",
          isRate: true,
          format: "float",
        },
        {
          id: "avg_clients_age",
          label: "AVG Clients Age",
          role: ["1", "5", "6"],
          isDisabled: false,
          color: "205,100,0",
        },
        {
          id: "mailinblack_done",
          label: "Mailinblack done",
          role: ["1", "5", "6"],
          isDisabled: false,
          color: "105,150,0",
          isRate: true,
          format: "float",
        },
        {
          id: "er_total",
          label: "Answers M&A",
          role: ["1", "5", "6"],
          isDisabled: false,
          color: "74, 3, 124",
        },
        {
          id: "er_positive",
          label: "Positive / MAR",
          role: ["1", "5", "6"],
          isDisabled: false,
          color: "83, 226, 129", // #3ecf17
        },
        {
          id: "er_manualpositive",
          label: "Manual Positive / MAR",
          role: ["1", "5", "6"],
          isDisabled: false,
          color: "80, 229, 130",
        },
        {
          id: "er_introduction",
          label: "Introduction / MAR",
          role: ["1"],
          isDisabled: false,
          color: "64, 245, 125",
        },
        {
          id: "er_negative",
          label: "Negative / MAR",
          role: ["1"],
          isDisabled: false,
          color: "255, 164, 164",
        },
        {
          id: "er_notscope",
          label: "Not scope / MAR",
          role: ["1"],
          isDisabled: false,
          color: "255, 91, 91",
        },
        {
          id: "er_wrong",
          label: "Wrong / MAR",
          role: ["1"],
          isDisabled: false,
          color: "255, 18, 18",
        },
        {
          id: "er_donotcontact",
          label: "Do not contact / MAR",
          role: ["1"],
          isDisabled: false,
          color: "179, 0, 0",
        },
        {
          id: "er_nottaggued",
          label: "Not taggued / MAR",
          role: ["1"],
          isDisabled: false,
          color: "255, 244, 26",
        },
        {
          id: "er_automatic",
          label: "Automatic Answer / Sent emails",
          role: ["1"],
          isDisabled: false,
          color: "0, 201, 237",
        },
        {
          id: "touchpoint_avg",
          label: "AVG Touchpoint",
          role: ["1"],
          isDisabled: false,
          color: "234, 0, 0",
          isRate: true,
          format: "float",
        },
        {
          id: "ideal_touchpoint_avg",
          label: "AVG Ideal Touchpoint",
          role: ["1"],
          isDisabled: false,
          color: "234, 0, 0",
          isRate: true,
          format: "float",
        },
        {
          id: "pay_declined_prctg",
          label: "Payement declined %",
          role: ["1"],
          isDisabled: false,
          color: "255,0,0",
          isRate: true,
          format: "float",
        },
        {
          id: "email_sent_acc",
          label: "Email sent / PEA",
          role: ["1"],
          isDisabled: false,
          color: "88,209,4",
          isRate: true,
          format: "float",
        },
        {
          id: "acc_avg",
          label: "AVG PEA / Client",
          role: ["1"],
          isDisabled: false,
          color: "0,255,50",
          isRate: true,
          format: "float",
        },
        {
          id: "reactivation_rate",
          label: "Reactivation rate",
          role: ["1"],
          isDisabled: false,
          color: "4, 110, 9",
          isRate: true,
          format: "float",
        },
        {
          id: "churn_rate",
          label: "Churn rate",
          role: ["1"],
          isDisabled: false,
          color: "22, 55, 199",
          isRate: true,
          format: "float",
        },
        {
          id: "unique_contacts",
          label: "Unique contacts",
          role: ["1"],
          isDisabled: false,
          color: "22, 55, 199",
          isRate: true,
          format: "float",
        },
        {
          id: "unique_contacts_prc",
          label: "Unique contacts %",
          role: ["1"],
          isDisabled: false,
          color: "22, 55, 199",
          isRate: true,
          format: "float",
        },
        {
          id: "recovered_recovery",
          label: "Recovered Revenue",
          role: ["1"],
          isDisabled: false,
          color: "209, 4, 91",
          isRate: true,
          format: "float",
        },
        {
          id: "credits",
          label: "Credits",
          role: ["1"],
          isDisabled: false,
          color: "209, 4, 91",
        },
        {
          id: "claims",
          label: "Claims",
          role: ["1"],
          isDisabled: false,
          color: "209, 4, 91",
        },
        {
          id: "avg_contact_age",
          label: "AVG Contact age",
          role: ["1"],
          isDisabled: false,
          color: "209, 4, 91",
          isRate: true,
          format: "float",
        },
        {
          id: "avg_contact_age_s1",
          label: "AVG Contact Age STEP 1",
          role: ["1"],
          isDisabled: false,
          color: "22, 55, 199",
          isRate: true,
          format: "float",
        },
        // {
        //   // SPARK FIRST SYNC
        //   id: "task_history_1",
        //   label: "AVG TIME Spark first sync",
        //   role: ["1"],
        //   isDisabled: false,
        //   color: "138, 218, 178",
        //   isRate: true,
        //   format: "float",
        // },
        // {
        //   // SPARK RE SYNC
        //   id: "task_history_2",
        //   label: "AVG TIME Spark Re-Sync",
        //   role: ["1"],
        //   isDisabled: false,
        //   color: "208, 242, 136",
        //   isRate: true,
        //   format: "float",
        // },
        // {
        //   // BLOCKED OUTLOOK
        //   id: "task_history_3",
        //   label: "AVG TIME Blocked Outlook emails",
        //   role: ["1"],
        //   isDisabled: false,
        //   color: "248, 255, 210",
        //   format: "float",
        // },
        // {
        //   // EMAILS EN ATTENTE DE CRÉATION
        //   id: "task_history_5",
        //   label: "AVG TIME Emails awaiting creation",
        //   role: ["1"],
        //   isDisabled: false,
        //   color: "223, 130, 108",
        //   isRate: true,
        //   format: "float",
        // },
        // {
        //   // SMTP ECHEC D AUTHENTIFICATION
        //   id: "task_history_6",
        //   label: "AVG TIME SMTP Auth failure",
        //   role: ["1"],
        //   isDisabled: false,
        //   color: "205, 141, 122",
        //   isRate: true,
        //   format: "float",
        // },
        // {
        //   // DOMAIN CONFIG
        //   id: "task_history_8",
        //   label: "AVG TIME Domain Config",
        //   role: ["1"],
        //   isDisabled: false,
        //   color: "219, 204, 149",
        //   isRate: true,
        //   format: "float",
        // },
        // {
        //   // LANDING PAGE
        //   id: "task_history_10",
        //   label: "AVG TIME Landing Page",
        //   role: ["1"],
        //   isDisabled: false,
        //   color: "234, 236, 204",
        //   isRate: true,
        //   format: "float",
        // },
        // {
        //   // BUY DOMAIN
        //   id: "task_history_12",
        //   label: "AVG TIME Buy Domain",
        //   role: ["1"],
        //   isDisabled: false,
        //   color: "195, 226, 194",
        //   isRate: true,
        //   format: "float",
        // },
        // {
        //   // TARGET MISSING DATA
        //   id: "task_history_13",
        //   label: "AVG TIME Target Missing Data",
        //   role: ["1"],
        //   isDisabled: false,
        //   color: "195, 226, 194",
        //   isRate: true,
        //   format: "float",
        // },
        // {
        //   // AVG TIME Contact supply
        //   id: "task_history_14",
        //   label: "AVG TIME Contact supply",
        //   role: ["1"],
        //   isDisabled: false,
        //   color: "195, 226, 194",
        //   isRate: true,
        //   format: "float",
        // },
        // {
        //   // AVG TIME order performaces
        //   id: "task_history_15",
        //   label: "AVG TIME Order performances",
        //   role: ["1"],
        //   isDisabled: false,
        //   color: "195, 226, 194",
        //   isRate: true,
        //   format: "float",
        // },
        // {
        //   // AVG TIME WARMY
        //   id: "task_history_16",
        //   label: "AVG TIME Warmy",
        //   role: ["1"],
        //   isDisabled: false,
        //   color: "195, 226, 194",
        //   isRate: true,
        //   format: "float",
        // },
        // {
        //   // COMMERCIAL WITHOUT EMAIL
        //   id: "task_history_17",
        //   label: "AVG TIME Commercial without email",
        //   role: ["1"],
        //   isDisabled: false,
        //   color: "195, 226, 194",
        //   isRate: true,
        //   format: "float",
        // },
        // SPAM CHECK DELIVERABILITY
        // {
        //   id: "spam_check_deliver_prc",
        //   label: "SPAM CHECK DELIVERAVILTY",
        //   role: ["1"],
        //   isDisabled: false,
        //   color: "195, 226, 194",
        //   isRate: true,
        //   format: "float",
        // },
        {
          id: "business_contact_actives",
          label: "Business Contacts - Created",
          role: ["1"],
          type: "line",
          isDisabled: false,
          color: "195, 226, 194",
        },
        {
          id: "business_contact_deleted",
          label: "Business Contacts - Deleted",
          role: ["1"],
          type: "line",
          isDisabled: false,
          color: "23, 2, 194",
        },
        {
          id: "business_contact_bounces",
          label: "Business Contacts - Bounces",
          role: ["1"],
          isDisabled: false,
          color: "9, 21, 10",
        },
        {
          id: "business_contact_pending",
          label: "Business Contacts - Pending Search",
          role: ["1"],
          isDisabled: false,
          color: "33, 20, 33",
        },
        {
          id: "business_contact_notfound",
          label: "Business Contacts - Not Found",
          role: ["1"],
          isDisabled: false,
          color: "180, 2, 2",
        },
      ],
      meetings_details_by_client: [],
      openchart: false,
      loadingWorkspace: false,
      meetings_details: [],
      tab: 1,
      timechart: "day",
      calendlyid: 0,
      opentotals: false,
      lastusers: [],
      totalev: {},
      cols: [],
      groups: [],
      teamgroups: [],
      clientsInit: [],
      cantgroups: 2,
      headers: [],
      cols3: [],
      headers3: [],
      cols4: [],
      headers4: [],
      gmaillist: [],
      keytable: 100,
      activecampaigns: [],
      model: {},
      keygmail: 200,
      loadinggmail: false,
      keylinkedin: 200,
      loadinglinkedin: false,
      linkedinlist: [],
      datePickerConfig: {
        format: "YYYY-MM-DD",
        useCurrent: false,
        // minDate: moment().startOf("day")
        maxDate: moment().endOf("day"),
      },
      datePickerConfigEndDate: {
        format: "YYYY-MM-DD",
        useCurrent: false,
        maxDate: moment().endOf("day"),
      },
      range: {
        startDate: moment().subtract(30, "days").format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
      },
      clientSignedOn: {
        startDate: null,
        endDate: null,
      },
      launchDate: {
        startDate: null,
        endDate: null,
      },
      groupedmeetignsmonth: {
        labels: [],
        datasets: [
          {
            type: "line",
            label: "Data One",
            backgroundColor: "#52BE80",
            data: [],
          },
          {
            type: "line",
            label: "Data Two",
            backgroundColor: "#dc3545",
            data: [],
          },
          {
            type: "line",
            label: "Data Three",
            backgroundColor: "#ffc107",
            data: [],
          },
        ],
        options: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            xAxes: [
              {
                stacked: true,
                categoryPercentage: 0.5,
                barPercentage: 1,
                time: {
                  unit: "month",
                  displayFormats: {
                    month: "M YYYY",
                  },
                },
              },
            ],
            yAxes: [
              {
                type: "linear",
                stacked: true,
                id: "y2",
                min: 0,
                max: 100,
                position: "left",
                display: true,
                ticks: {
                  beginAtZero: true,
                  stepSize: 10,
                  min: 0,
                  max: 100,
                },
              },
            ],
          },
        },
      },
      groupedmeetignsweek: {
        labels: [],
        datasets: [
          {
            type: "line",
            label: "Data One",
            backgroundColor: "#52BE80",
            data: [],
          },
          {
            type: "line",
            label: "Data Two",
            backgroundColor: "#dc3545",
            data: [],
          },
          {
            type: "line",
            label: "Data Three",
            backgroundColor: "#ffc107",
            data: [],
          },
        ],
        options: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            xAxes: [
              {
                stacked: true,
                categoryPercentage: 0.5,
                barPercentage: 1,
                time: {
                  unit: "week",
                  displayFormats: {
                    week: "W YYYY",
                  },
                },
              },
            ],
            yAxes: [
              {
                type: "linear",
                stacked: true,
                id: "y2",
                min: 0,
                max: 100,
                position: "left",
                display: true,
                ticks: {
                  beginAtZero: true,
                  stepSize: 10,
                  min: 0,
                  max: 100,
                },
              },
            ],
          },
        },
      },
      groupedmeetigns: {
        labels: [],
        datasets: [
          {
            type: "line",
            label: "Data One",
            backgroundColor: "#52BE80",
            data: [],
          },
          {
            type: "line",
            label: "Data Two",
            backgroundColor: "#dc3545",
            data: [],
          },
          {
            type: "line",
            label: "Data Three",
            backgroundColor: "#ffc107",
            data: [],
          },
        ],
        options: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            xAxes: [
              {
                stacked: true,
                categoryPercentage: 0.5,
                barPercentage: 1,
                time: {
                  unit: "day",
                },
              },
            ],
            yAxes: [
              {
                type: "linear",
                stacked: true,
                id: "y2",
                min: 0,
                max: 100,
                position: "left",
                display: true,
                ticks: {
                  beginAtZero: true,
                  stepSize: 10,
                  min: 0,
                  max: 100,
                },
              },
            ],
          },
        },
      },
      multiaxismonth: {
        labels: [],
        datasets: [
          {
            type: "bar",
            label: "Meetings",
            borderColor: "RGB(133,43,242,1)",
            backgroundColor: "RGBA(133,43,242,0.51)",
            pointBackgroundColor: "rgba(220,220,220,1)",
            yAxisID: "y2",
            data: [],
          },
        ],
        options: {
          responsive: true,
          title: {
            display: true,
            text: this.$t("lang.label.activity"),
          },
          scales: {
            yAxes: [
              {
                type: "linear",
                id: "y1",
                position: "right",
                display: true,
                gridLines: {
                  drawOnChartArea: false,
                },
                ticks: {
                  beginAtZero: true,
                },
              },
              {
                type: "linear",
                id: "y3",
                position: "right",
                display: true,
                gridLines: {
                  drawOnChartArea: false,
                },
                ticks: {
                  beginAtZero: true,
                },
              },
              {
                type: "linear",
                id: "y2",
                position: "left",
                display: true,
                ticks: {
                  beginAtZero: true,
                },
              },
            ],
            xAxes: [
              {
                type: "time",
                time: {
                  unit: "month",
                },
                stacked: false,
                offset: true,
                gridLines: {
                  display: false,
                },
              },
            ],
          },
        },
      },
      multiaxisweek: {
        labels: [],
        datasets: [
          {
            type: "bar",
            label: "Meetings",
            borderColor: "RGB(122,43,242,1)",
            backgroundColor: "RGBA(133,23,242,0.51)",
            pointBackgroundColor: "rgba(110,220,220,1)",
            yAxisID: "y2",
            data: [],
          },
        ],
        options: {
          responsive: true,
          title: {
            display: true,
            text: this.$t("lang.label.activity"),
          },
          scales: {
            yAxes: [
              {
                type: "linear",
                id: "y1",
                position: "right",
                display: true,
                gridLines: {
                  drawOnChartArea: false,
                },
                ticks: {
                  beginAtZero: true,
                },
              },
              {
                type: "linear",
                id: "y3",
                position: "right",
                display: true,
                gridLines: {
                  drawOnChartArea: false,
                },
                ticks: {
                  beginAtZero: true,
                },
              },
              {
                type: "linear",
                id: "y2",
                position: "left",
                display: true,
                ticks: {
                  beginAtZero: true,
                },
              },
            ],
            xAxes: [
              {
                type: "time",
                time: {
                  unit: "week",
                  displayFormats: {
                    week: "W YYYY",
                  },
                },
                offset: true,
                gridLines: {
                  display: true,
                },
              },
            ],
          },
        },
      },
      multiaxis: {
        labels: [],
        datasets: [],
        options: {
          responsive: true,
          title: {
            display: true,
            text: this.$t("lang.label.activity"),
          },
          scales: {
            yAxes: [
              {
                type: "linear",
                id: "y1",
                position: "right",
                display: true,
                gridLines: {
                  drawOnChartArea: false,
                },
                ticks: {
                  beginAtZero: true,
                },
              },
              {
                type: "linear",
                id: "y3",
                position: "right",
                display: true,
                gridLines: {
                  drawOnChartArea: false,
                },
                ticks: {
                  beginAtZero: true,
                },
              },
              {
                type: "linear",
                id: "y2",
                position: "left",
                display: true,
                ticks: {
                  beginAtZero: true,
                },
              },
            ],
            xAxes: [
              {
                type: "time",
                time: {
                  unit: "day",
                },
                stacked: false,
                offset: true,
                gridLines: {
                  display: false,
                },
              },
            ],
          },
        },
      },
    };
  },
  components: {
    TabItem,
    LineChart,
    LoadingSpinner,
    DashboardStatistics,
    ContactsAvailable,
    Tutorial,
    Fieldset,
    Table,
    TableMonitor,
    CalendlyEvent,
    Treeselect,
    EmailSyncList,
    Checkhttps,
    ManageWorkspace,
    EmailQueueStats,
    AccountEmailList,
    BusinessContactEmailList,
    FilterSystem,
    AllEmails,
    DoughnutChart,
    DomainList,
    DashboardReportCredit,
    Metrics,
    OperatorsAvgTime,
    BookerCallUnreachable,
    PhoneDirectory,
    ZapmailManageWorkspace,
    RevenueClient,
  },

  mixins: [
    statusBadgeMixin,
    statusPointMixin,
    statusFeedNotificationsMixin,
    formattersMixin,
  ],

  computed: {
    user() {
      return this.$store.state.authentication.user;
    },
    ...mapState({
      loading: (state) => state.campaigns.loading,
      campaigns: (state) => state.campaigns.alldashboard.data,
      currentUser: (state) => state.authentication.user,
      loadingStats: (state) => state.campaigns.loadingStats,
      stats: (state) => state.campaigns.stats.data,
      plans: (state) => state.plans.all,
      Languages: (state) => state.optionsList.all["languages"].data,
    }),
    toastNotificationData() {
      return this.$store.state.authentication.toastNotificationData;
    },
    filteredOptionsByCategory() {
      if (!this.type_stats) {
        return [];
      }

      // Mapping of categories to option IDs
      const categoryMap = {
        revenue: [
          "money_without_tax", // CA HT
          "money", // CA TTC
          "money_meetings_without_tax", // Average Meeting Price
          "billing", // Facturation TTC
          "pay_declined_prctg", // Payement declined %
          "cashed", // Total rendez-vous effectués encaissés
        ],
        meetings: [
          "meetings", // Meetings
          "conversion_rate", // Converstion rate
          "cancel_meetings_rate", // Cancel Meetings Rate
          "meeting_qty", // Meetings Full
          "planned_qty", // Planned Qty
          "charged_qty", // Charged Qty
          "uncharged_qty", // Uncharged Qty
          "declined_rate", // Declined rate
          "declined_qty", // Declined Qty
          "cancel_rate", // Cancel rate
          "cancel_qty", // Cancel Qty
          "absent_rate", // Absent rate
          "absent_qty", // Absent Qty
        ],
        sendings: [
          "sent", // Sent
          "bounce_total", // Bounces
          "bounce_prc", // Bounces %
          "scheduled", // Scheduled
          "newprospects", // New Prospects
          "newprospects_first", // New Prospects (first time)
          "newprospects_first_prctg", // New Prospects (first time) %
          "recurringsent", // Recurring Sent
          "recurringsent2", // Step 2
          "recurringsent3", // Step 3
          "recurringsent4", // Step 4
          "recurringsent5", // Step 5
          "recurringsent6", // Step 6
          "touchpoint_avg", // Touchpoint AVG
          "ideal_touchpoint_avg", // Ideal Touchpoint AVG
          "email_sent_acc", // Email sent / PEA
          "acc_avg", // AVG PEA / Client
          "unique_contacts", // Unique contacts
          "unique_contacts_prc", // Unique contacts %
          "avg_contact_age", // AVG Contact age
          "avg_contact_age_s1", // Contact Age AVG STEP 1
        ],
        clicks_answers: [
          "sessions", // clic calendar
          "calendar_click_rate", // Calendar click rate
          "response_rate", // MAR (Manual Answer Rate)
          "accounts_sent", // Accounts sent
          "er_total", // Answers M&A
          "er_positive", // Positive / MAR
          "er_manualpositive", // Manual Positive / MAR
          "er_introduction", // Introduction / MAR
          "er_negative", // Negative / MAR
          "er_notscope", // Not scope / MAR
          "er_wrong", // Wrong / MAR
          "er_donotcontact", // Do not contact / MAR
          "er_nottaggued", // Not taggued / MAR
          "er_automatic", // Automatic Answer / Sent emails
        ],
        projections: [
          "projsend", // Projection sending
          "projsend_new", // Projection sending new
          "projsend_recurring", // Projection sending recurring
          "projsend_recurring2", // Proj Step 2
          "projsend_recurring3", // Proj Step 3
          "projsend_recurring4", // Proj Step 4
          "projsend_recurring5", // Proj Step 5
          "projsend_recurring6", // Proj Step 6
          "projsend_meetings", // Proj meetings
          "projsend_money", // Proj CA TTC
        ],
        calls: [
          "number_of_calls", // Based on "Appels passés" (Total calls placed).
          "number_of_calls_picked_up", // Picked Up**: Based on "Appels décrochés" (Total calls answered).
          "per_of_calls_picked_up", // The ratio of answered calls vs. total calls.
          "meeting_rate_calls", // Based on "Meeting pris en cold-call" (Conversion rate from call to meeting).
        ],
        data: [
          "new_contact_mobile", // New Contact Mobile
          "new_contact_email", // New Contact Email
          "domains_age", // Domains age
          "contactsintarget", // Contacts Added into targets
          "business_contact_actives", // Business Contacts - Created
          "business_contact_deleted", // Business Contacts - Deleted
          "business_contact_bounces", // Business Contacts - Bounces
          "business_contact_pending", // Business Contacts - Pending Search
          "business_contact_notfound", // Business Contacts - Not Found
        ],
        bookers: [
          "lost_meeting_rate_cold", // Lost Meeting Rate Cold %
          "booker_call_test", // Booker Call test
          "new_bookers", // New Bookers
          "booker_meetings_prc", // Booker impact %
          "active_bookers", // Active Bookers
          "bookers_verified_calls", // Bookers Verified Calls
          "bookers_verified_answers", // Bookers Verified Answers
          "bookers_meeting_rate_ubs_5", // Booker level 2 meeting rate
          "bookers_meeting_rate_ubs_6", // Booker manager meeting rate
        ],
        account_management: [
          "validated_orders", // Validated orders
          "new_teams", // New Teams
          "canceled_meetings_verification", // Canceled Meetings Verification
          "mailinblack_done", // Mailinblack done
          "manual_tagged_er", // Manual tagged responses
          "manual_tagged_er_prctg", // Manual tagged responses %
          "active_clients", // Active Clients
          "avg_clients_age", // Average Clients Age
          "reactivation_rate", // Reactivation rate
          "churn_rate", // Churn rate
          "recovered_recovery", // Recovered Recovery
          "credits", // Credits
          "claims",  // Claims
        ],
      };

      const allowedIds = categoryMap[this.type_stats] || [];
      
      if (!this.optselect || !Array.isArray(this.optselect)) {
        return [];
      }
      
      return this.optselect.filter((option) => option && option.id && allowedIds.includes(option.id));
    },
  },
  watch: {
    loadingStats: function () {
      this.loadStatsData();
    },
    "$route.params.tab": {
      handler(newTab) {
        if (newTab == 1) {
          this.type_stats = "sendings";
this.$nextTick(() => {
          this.filters.type = ["sent", "newprospects"];
          this.loadRangeStats(true);
          });
        }
      },
      immediate: true,
    },
  },

  mounted() {
    if (this.$route.query.code) {
      let code = this.$route.query.code;
      adminService.sendCodeGoogle(code).then((res) => {
        if (res && res.warning == "ms_personal_account") {
          this.$swal({
            type: "warning",
            title: "Microsoft",
            text: this.$t("lang.appointments.ms_personal_account"),
            showConfirmButton: true,
          });
        } else if (res) {
          this.$swal({
            type: "success",
            title: "success",
            text: "account synced successfully",
            showConfirmButton: false,
            timer: 2000,
          });
        }
      });
    }

    if (this.tab == 21) {
      this.getDataMetrics = !this.getDataMetrics;
    }

    // Embed en AgencyForm (clientId): mismo comportamiento que tab 1 por ruta
    if (this.clientId != null && this.tab == 1) {
      this.type_stats = "sendings";
      this.$nextTick(() => {
        this.filters.type = ["sent", "newprospects"];
        this.loadRangeStats(true);
      });
    }
  },
  created() {
    this.$store.dispatch("optionsList/getLanguages").then(() => {
      this.langs = this.Languages.filter((el, i) => i < 4);
    });
    if (this.$route.params.tab !== undefined) {
      this.tab = this.$route.params.tab
      this.changeThisTab(this.tab);
    }

    this.cols = [
      [
        {
          value: "creation_date",
        },
      ],
      [
        {
          value: "name",
        },
      ],
      [
        {
          value: "lastname",
        },
      ],
      [
        {
          value: "email",
        },
      ],
    ];
    this.headers = [
      {
        label: this.$t("lang.column.creationdate"),
        size: "130px",
        class: "overflowhide",
      },
      {
        label: this.$t("lang.column.name"),
        size: "80px",
        class: "overflowhide",
      },
      {
        label: this.$t("lang.column.lastname"),
        size: "80px",
        class: "overflowhide",
      },
      {
        label: this.$t("lang.column.email"),
        size: "100px",
        class: "overflowhide",
      },
    ];

    this.headers3 = [
      {
        label: "id",
        size: "130px",
        class: "overflowhide",
      },
      {
        label: this.$t("lang.label.name"),
        size: "130px",
        class: "overflowhide",
      },
      {
        label: this.$t("lang.label.status"),
        size: "130px",
        class: "overflowhide",
      },
      {
        label: "Total points",
        size: "130px",
        class: "overflowhide",
      },
      {
        label: "Processed points",
        size: "130px",
        class: "overflowhide",
      },
      {
        label: "Business found",
        size: "130px",
        class: "overflowhide",
      },
      {
        label: "Bussiness processed",
        size: "130px",
        class: "overflowhide",
      },
      {
        label: "Imported",
        size: "130px",
        class: "overflowhide",
      },
      {
        label: this.$t("lang.label.industry"),
        size: "130px",
        class: "overflowhide",
      },
      {
        label: "Linkedin",
        size: "130px",
        class: "overflowhide",
      },
      {
        label: "Created",
        size: "130px",
        class: "overflowhide",
      },
      {
        label: "Updated",
        size: "130px",
        class: "overflowhide",
      },
      {
        label: "Time",
        size: "130px",
        class: "overflowhide",
      },
    ];

    this.cols3 = [
      [
        {
          value: "id",
        },
      ],
      [
        {
          value: "name",
        },
      ],
      [
        {
          value: "status",
          icons: [
            {
              icon_if_value: "finished",
              icon_true: "icon-checkmark text-success",
            },
            {
              icon_if_value: "pending",
              icon_true: "icon-clock text-secondary",
            },
            {
              icon_if_value: "paused",
              icon_true: "icon-pause text-warning",
            },
            {
              icon_if_value: "processing",
              icon_true: "icon-download text-primary",
            },
          ],
        },
      ],
      [
        {
          value: "point_total",
        },
      ],
      [
        {
          value: "point_processed",
        },
      ],
      [
        {
          value: "total",
        },
      ],
      [
        {
          value: "finished",
        },
      ],
      [
        {
          value: "imported",
        },
      ],
      [
        {
          value: "industry",
        },
      ],
      [
        {
          value: "searchlinkedin",
        },
      ],
      [
        {
          value: "created",
        },
      ],
      [
        {
          value: "updated",
        },
      ],
      [
        {
          value: "difference",
        },
      ],
    ];
    this.headers4 = [
      {
        label: "id",
        size: "130px",
        class: "overflowhide",
      },
      {
        label: this.$t("lang.label.name"),
        size: "130px",
        class: "overflowhide",
      },
      {
        label: this.$t("lang.label.status"),
        size: "130px",
        class: "overflowhide",
      },
      {
        label: "job_id",
        size: "130px",
        class: "overflowhide",
      },
      {
        label: "Total",
        size: "130px",
        class: "overflowhide",
      },
      {
        label: "Processed",
        size: "130px",
        class: "overflowhide",
      },
      {
        label: "Imported",
        size: "130px",
        class: "overflowhide",
      },
      {
        label: "Created",
        size: "130px",
        class: "overflowhide",
      },
      {
        label: "Updated",
        size: "130px",
        class: "overflowhide",
      },
      {
        label: "Time",
        size: "130px",
        class: "overflowhide",
      },
    ];

    this.cols4 = [
      [
        {
          value: "id",
        },
      ],
      [
        {
          value: "name",
        },
      ],
      [
        {
          value: "status",
          icons: [
            {
              icon_if_value: "imported",
              icon_true: "icon-checkmark text-success",
            },
            {
              icon_if_value: "pending",
              icon_true: "icon-clock text-secondary",
            },
            {
              icon_if_value: "importing",
              icon_true: "icon-download text-primary",
            },
          ],
        },
      ],
      [
        {
          value: "job_id",
        },
      ],
      [
        {
          value: "result",
        },
      ],
      [
        {
          value: "processed",
        },
      ],
      [
        {
          value: "imported",
        },
      ],
      [
        {
          value: "created",
        },
      ],
      [
        {
          value: "updated",
        },
      ],
      [
        {
          value: "difference",
        },
      ],
    ];

    let opt = this.options;
    this.options.forEach((r, index) => {
      if (r && r.role && r.role.indexOf(this.currentUser.role_id) >= 0) {
        if (r.isDisabled) {
          r.label = r.label + " (coming soon)";
        }
        this.optselect.push(r);
      }
    });

    this.sendingMethods.forEach((r, index) => {
      if (r.role.indexOf(this.currentUser.role_id) >= 0) {
        if (r.isDisabled) {
          r.label = r.label + " (coming soon)";
        }
      }
    });

    this.myTeamList();
  },
  methods: {
    ...mapActions("campaigns", {
      getAllCampaigns: "getInfoCampaigns",
    }),
    ...mapActions("campaigns", {
      getCampaignStatsByIdAndRange: "getStatsByIdAndRange",
    }),
    ...mapActions("header", {
      changeHeaderTab: "changeTab",
    }),
    includeOption(option) {
      return this.filters.type.includes(option);
    },
    filterTypeChanged() {
      if (this.includeOption("billing")) {
        this.filters.sendingMethods = [];
        this.filters.sendingProviders = [];
      }
    },
    toggleAdvancedFilters() {
      if (this.showAdvancedFilters) {
        this.resetAdvancedFilters();
      }
      this.showAdvancedFilters = !this.showAdvancedFilters;
    },
    resetAdvancedFilters() {
      this.clients = [];
      this.filters.clientSignedOn = { startDate: null, endDate: null };
      this.clientSignedOn = { startDate: null, endDate: null };
      this.filters.orderLanguage = [];
      this.filters.warmupActive = null;
      this.filters.launchDate = { startDate: null, endDate: null };
      this.launchDate = { startDate: null, endDate: null };
      this.filters.sendingMethods = [];
      this.filters.sendingProviders = [];
    },
    normalizerLangs(node) {
      return {
        id: node.id,
        label: node.name,
      };
    },
    hasPermissions(perm) {
      return this.$store.getters["authentication/hasPermissions"](perm);
    },
    openWorkspace(project, zapmail = false, zapmail_id = 0) {
      this.project = project;
      if (zapmail) {
        this.zapmailid = zapmail_id;
        this.$modal.show("zapmailmanageworkspace");
        return;
      }
      this.$modal.show("manageworkspace");
      return;
    },
    openZapmailModal(zapmail_id){
      this.loadingWorkspace = true;
      workspaceService.getWorkspaceDomains('', '', '', zapmail_id).then((result) => {
        this.zapmailDomains = result;
        this.loadingWorkspace = false;
      });
      this.$modal.show("zapmail");
      return;
    },
    getTittle(){
        if(this.tab == 1){
          return this.$t("lang.label.statistics");
        }
        if(this.tab == 8){
          return this.$t("lang.label.meetings");
        }
        if(this.tab == 3){
          return this.$t("lang.label.workspaces");
        }
        if(this.tab == 10){
          return this.$t("lang.label.queue-emails");
        }
        if(this.tab == 19){
          return this.$t("lang.label.business-contacts");
        }
        if(this.tab == 22){
          return this.$t("lang.label.meetings-dispertion");
        }
        if(this.tab == 21){
          return this.$t("lang.label.metrics");
        }
        if(this.tab == 24){
          return this.$t("lang.label.operators");
        }
        if(this.tab == 28){
          return this.$t("lang.label.phone_directory");
        }
        if(this.tab == 11){
          return this.$t("lang.label.mailboxes");
        }
        return "";
    },
    openModal(type, arg) {
      this.loadingWorkspace = true;
      if (type == "workspace") {
        this.workspacedomains = false;
        this.$modal.show(type);
        workspaceService.getWorkspaceDomains(arg).then((result) => {
          this.workspacedomains = result;
          this.loadingWorkspace = false;
        }).catch((error) => {
          console.error("Error loading workspaces:", error);
          this.loadingWorkspace = false;
        });
        return;
      }

      if (type == "pending") {
        this.pendingdomains = false;
        workspaceService.getWorkspaceDomains().then((result) => {
          this.pendingdomains = result;
        });
        this.$modal.show(type);
        this.loadingWorkspace = false;
        return;
      }

      if (type == "domain") {
        this.closeModal("workspace");
        this.openDomain(arg);
        this.$modal.show(type);
        this.loadingWorkspace = false;
        return;
      }

      this.$modal.show(type);
    },
    closeModal(type) {
      this.$modal.hide(type);
    },
    showNow(client_id) {
      this.showteam = client_id;
    },
    openDomain(arg) {
      this.workspaceusers = false;
      workspaceService.getWorkspaceUsersDomain(arg).then((result) => {
        this.workspaceusers = result;
      });
      return;
    },
    showThisItem(item, not) {
      if (item.type == "workspace") {
        if (
          (not.entity_type == "emailworkspace" && not.ref_id == "2") ||
          (not.entity_type == "buydomain" && not.ref_id == "1")
        ) {
          return true;
        }
      }
      if (item.type == "workspacecom") {
        if (
          not.entity_type == "buydomain" ||
          not.entity_type == "emailworkspace" ||
          not.entity_type == "workspacedomain" ||
          not.entity_type == "dnsdomain"
        ) {
          return true;
        }
      }

      if (item.type == "campaigns") {
        if (not.entity_type == "campaignerror") {
          return true;
        }
      }
      if (item.type == "campaignsupporterror") {
        if (not.entity_type == "campaignsupporterror") {
          return true;
        }
      }
      if (item.type == "workflows") {
        if (not.entity_type == "workflowerror") {
          return true;
        }
      }
      if (item.type == "contracts") {
        if (not.entity_type == "validationdate") {
          return true;
        }
      }
      if (item.type == "payments") {
        if (not.entity_type == "paymenterror") {
          return true;
        }
      }
      return false;
    },
    permissionFront() {
      return (
        (this.currentUser.team_role_id == undefined ||
          this.currentUser.team_role_id != 3) &&
        this.currentUser.role_id != 4
      );
    },
    getClass(opportunity) {
      if (opportunity.link_status_reason_id == 35) {
        return "badge badge-warning";
      }
      if (opportunity.link_status_reason_id == 34) {
        return "badge badge-danger";
      }
      if (opportunity.link_status_reason_id == 24) {
        return "badge badge-success";
      }
      return "";
    },
    getText(opportunity) {
      if (opportunity.link_status_reason_id == 35) {
        return this.$t("lang.refuse.absentlabel");
      }
      if (opportunity.link_status_reason_id == 34) {
        return this.$t("lang.refuse.refused");
      }
      if (opportunity.link_status_reason_id == 24) {
        return this.$t("lang.refuse.valid");
      }
      return "";
    },
    getTotalStatus(list, status) {
      let cant;
      cant = 0;
      list.forEach((r) => {
        if (r.status == status) {
          cant++;
        } else {
          if (!r.status && status == 24) {
            cant++;
          }
        }
      });
      return cant;
    },
    getEventRow(eventdate) {
      if (eventdate == null) {
        return false;
      }
      let ev = eventdate.split(",");
      return ev;
    },
    getEventDate(ev, r) {
      return ev.split("|")[r];
    },
    getClassBadge(status) {
      if (status == "canceled") {
        return "text-white bg-danger";
      }
      if (status == "active") {
        return "text-white bg-success";
      }
    },
    changeThisTab(id) {
      if (id == 3) {
        workspaceService.getWorkspaceAdmins().then((result) => {
          this.workspace = result;
        });

        adminService.getOliverVariables("activenylas").then((result) => {
          this.activenylas = result;
        });
      }
      if (id > 3 && id < 7) {
        usersService.getNotificationsIssues().then((result) => {
          this.notif = result;
        });
      }
      if (id == 1 && this.currentUser.role_id !== "1") {
        this.loadRangeStats();
      }
      if (id == 1) {
        this.filters.type = [];
      }

      if (id == 21) {
        this.range.startDate = moment().format("YYYY-MM-DD");
      }

      this.tab = id;
    },
    getTotal() {
      if (this.totalev.length == 0) {
        return false;
      }
      return this.totalev;
    },
    loadRappelActivity() {
      this.total = {};
      this.openlist = false;
      this.opentotals = false;
      campaignsService.getRappelActivity(2771).then((result) => {
        this.rappellist = result;
        this.openrappellist = true;
      });
    },
    loadAgencyStats() {
      this.graphsData = [];
      this.cardData = {};
      this.opentotals = false;
      this.openrappellist = false;
      this.total = {};

      if (this.tab == 22) {
        this.getDataLoading = true;
        this.filtersDash.getActivityByDateAndClient = true;
      } else {
        this.filtersDash = {};
      }
      campaignsService
        .getAgencyStatsRange(
          this.range.startDate,
          this.range.endDate,
          this.client,
          this.filtersDash
        )
        .then((result) => {
          this.meetings_details = result.activity_by_date;
          this.meetings_details_by_client = result.activity_by_date_client;
          this.openlist = true;
        }).catch((err) => {
          this.$swal({
            type: "warning",
            title: this.$t("lang.label.error"),
            html: this.$t("lang.general.error"),
            showConfirmButton: true,
          });
        })
        .finally(() => {
          this.getDataLoading = false;
        });
      if (this.tab != 22) {
        this.loadAgencyStatsGraphs();
      }
    },

    loadAgencyStatsGraphs() {
      this.graphsDataLoading = true;
      this.filtersDash.getGraphData = true;
      campaignsService
        .getAgencyStatsRange(
          this.range.startDate,
          this.range.endDate,
          this.client,
          this.filtersDash
        )
        .then((result) => {
          this.graphsData = [];
          this.cardData = {};
          Object.entries(result.activity_by_date).forEach((value, index) => {
            if (value[1].graph_type != "pie") {
              this.cardData[value[0]] = value[1].data;
              return;
            }

            if (value[1].data[0].label == null) {
              return;
            }

            let graphsDataN = {
              labels: [],
              datasets: [{ data: [], backgroundColor: [] }],
              options: {
                cutoutPercentage: 10,
                responsive: true,
                aspectRatio: 1,
                maintainAspectRatio: false,
                devicePixelRatio: 2,
                title: {
                  display: true,
                  text: this.$t("lang.column." + value[0]),
                  innerText: "",
                },
                legend: {
                  display: false,
                },
              },
            };
            value[1].data.forEach((item, index2) => {
              graphsDataN.labels.push(item.label);
              var randomColor = Math.floor(Math.random() * 16777215).toString(
                16
              );
              graphsDataN.datasets[0].backgroundColor.push("#" + randomColor);
              graphsDataN.datasets[0].data.push(item.total);
            });
            this.graphsData.push(graphsDataN);
          });
        })
        .catch((err) => {
          this.$swal({
            type: "warning",
            title: this.$t("lang.label.error"),
            html: this.$t("lang.general.error"),
            showConfirmButton: true,
          });
        })
        .finally(() => {
          this.graphsDataLoading = false;
        });
      this.filtersDash.getGraphData = false;
    },

    changeChart(type) {
      this.timechart = type;
    },
    loadMultiaxis() {
      this.options.forEach((r, index) => {
        if (this.filters.type.indexOf(r.id) >= 0) {
          if (r.id === "er_total") {
            return false;
          }

          let type = "bar";
          if (r.type) {
            type = r.type;
          }
          let yaxis = "y2";

          if (r.id == "answers") {
            yaxis = "y1";
          }

          if (
            ["meetings", "reprogramming", "accounts_sent", "acc_avg", "projsend_meetings", "declined_rate", "cancel_rate", "absent_rate"].includes(
              r.id
            )
          ) {
            type = "line";
            yaxis = "y1";
          }

          if (
            [
              "sent",
              "bounce_total",
              "scheduled",
              "newsent",
              "newprospects",
              "recurringsent",
              "recurringsent2",
              "recurringsent3",
              "recurringsent4",
              "recurringsent5",
              "recurringsent6",
              "er_total",
              "er_positive",
              "er_manualpositive",
              "er_negative",
              "er_introduction",
              "er_notscope",
              "er_wrong",
              "er_donotcontact",
              "er_nottaggued",
              "er_automatic",
              "projsend",
              "projsend_new",
              "projsend_recurring",
              "projsend_recurring2",
              "projsend_recurring3",
              "projsend_recurring4",
              "projsend_recurring5",
              "projsend_recurring6",
              "projsend_money",
              "planned_qty",
              "charged_qty",
              "uncharged_qty",
              "declined_qty",
              "cancel_qty",
              "absent_qty",

            ].includes(r.id)
          ) {
            let stack = "1";
            if (["recurringsent", "er_total", "newsent", "projsend"].includes(r.id)) {
              stack = "2";
            }
            if (["projsend_new", "projsend_recurring"].includes(r.id)) {
              stack = "3";
            }
            if (["projsend_recurring2", "projsend_recurring3", "projsend_recurring4", "projsend_recurring5", "projsend_recurring6",].includes(r.id)) {
              stack = "4";
            }
            yaxis = "y2";

            let days = {
              type: "bar",
              label: r.label,
              filter: r.id,
              yAxisID: yaxis,
              backgroundColor: "RGBA(" + r.color + ",0.65)",
              // borderColor: "RGB(" + r.color + ",0.65)",
              data: [],
              stack: stack,
            }

            let week = {
              type: "bar",
              label: r.label,
              filter: r.id,
              yAxisID: yaxis,
              backgroundColor: "RGBA(" + r.color + ",0.65)",
              // borderColor: "RGB(" + r.color + ",0.65)",
              data: [],
              stack: stack,
            }

            let month = {
              type: "bar",
              label: r.label,
              filter: r.id,
              yAxisID: yaxis,
              backgroundColor: "RGBA(" + r.color + ",0.65)",
              // borderColor: "RGB(" + r.color + ",0.65)",
              data: [],
              stack: stack,
            }

            if (
              [
                "er_positive",
                "er_manualpositive",
                "er_negative",
                "er_introduction",
                "er_notscope",
                "er_wrong",
                "er_donotcontact",
                "er_nottaggued",
                "er_automatic",
                "projsend_money",
              ].includes(r.id)
            ) {
              yaxis = "y3";
            }
            this.multiaxis.datasets.push(days);
            this.multiaxisweek.datasets.push(week);
            this.multiaxismonth.datasets.push(month);
            this.multiaxis.options.scales.xAxes = [
              {
                stacked: true,
                categoryPercentage: 0.5,
                barPercentage: 1,
                offset: true,
              },
            ];
          } else {
            this.multiaxis.datasets.push({
              type: type,
              label: r.label,
              hidden: false,
              filter: r.id,
              borderColor: "RGBA(" + r.color + ",1)",
              backgroundColor: "RGBA(" + r.color + ",0.28)",
              pointBackgroundColor: "RGBA(" + r.color + ",1)",
              yAxisID: yaxis,
              data: [],
            });
            this.multiaxisweek.datasets.push({
              type: type,
              label: r.label,
              hidden: false,
              filter: r.id,
              borderColor: "RGBA(" + r.color + ",1)",
              backgroundColor: "RGBA(" + r.color + ",0.28)",
              pointBackgroundColor: "RGBA(" + r.color + ",1)",
              yAxisID: yaxis,
              data: [],
            });
            this.multiaxismonth.datasets.push({
              type: type,
              label: r.label,
              hidden: false,
              filter: r.id,
              borderColor: "RGBA(" + r.color + ",1)",
              backgroundColor: "RGBA(" + r.color + ",0.28)",
              pointBackgroundColor: "RGBA(" + r.color + ",1)",
              yAxisID: yaxis,
              data: [],
            });
          }
        }
      });
    },
    getDetails() {
      this.loadAgencyStats();
    },
    getMultiaxisMonth(type) {
      let stats = this.stats;

      if (stats.activity_by_date[type] === undefined) {
        return;
      }

      let meetings = stats.activity_by_date[type];
      let labels = stats.activity_by_date.labels;
      let newlabels = [];
      let cantnewlabels = [];
      let indexof;
      let days = "";
      let day = "";
      let resmeetings = [];
      let reflabelmeeting = [];
      let datescols = [];

      var option = this.options.filter((c) => c.id == type);
      var isRate = option[0].isRate == undefined ? false : option[0].isRate;
      var format = option[0].format == undefined ? "integer" : option[0].format;

      labels.forEach((r, index) => {
        let days = r.split("-");
        day = new Date(days[0], days[1] - 1, days[2]);
        var refd = day.getFullYear() + "-" + days[1];
        if (reflabelmeeting.indexOf(refd) < 0) {
          reflabelmeeting.push(refd);
        }
        indexof = reflabelmeeting.indexOf(refd);
        if (newlabels[indexof] == undefined && meetings[index] !== undefined && meetings[index] !== '-') {
          if (format === "float") {
            newlabels[indexof] = 0 + parseFloat(meetings[index]);

            if (parseFloat(meetings[index]) > 0) {
              cantnewlabels[indexof] = 1;
            }
          } else {
            newlabels[indexof] = 0 + parseInt(meetings[index]);
          }
        } else {
          if (format === "float" && meetings[index] !== '-') {
            newlabels[indexof] =
              parseFloat(newlabels[indexof]) + parseFloat(meetings[index]);
            if (parseFloat(meetings[index]) > 0) {
              if (cantnewlabels[indexof] === undefined) {
                cantnewlabels[indexof] = 1;
              } else {
                cantnewlabels[indexof] += 1;
              }
            }
          } else if (meetings[index] !== '-') {
            newlabels[indexof] =
              parseInt(newlabels[indexof]) + parseInt(meetings[index]);
          }
        }
      });

      if (isRate) {
        newlabels.forEach((r, index) => {
          newlabels[index] = parseFloat(r / cantnewlabels[index]).toFixed(4);
        });
      }

      newlabels.forEach((quantity, index) => {
        resmeetings.push(quantity);
      });

      this.multiaxismonth.labels = reflabelmeeting;
      this.multiaxis.datasets.forEach((r, index) => {
        if (r.filter == type) {
          this.multiaxismonth.datasets[index].data = resmeetings;
        }
      });
    },
    getGroupMonth() {
      this.groupedmeetignsmonth.labels = this.stats.activity_by_date.labels;

      this.groupedmeetignsmonth.datasets[0].label = "Planned %";
      this.groupedmeetignsmonth.datasets[1].label = "Canceled %";
      this.groupedmeetignsmonth.datasets[2].label = "Absent %";

      let stats = this.stats;
      let labels = stats.activity_by_date.labels;
      let newplanned = [];
      let newcanceled = [];
      let newabsent = [];
      let indexof;
      let days = "";
      let day = "";
      let planned = this.stats.activity_by_date["planned"];
      let canceled = this.stats.activity_by_date["canceled"];
      let absent = this.stats.activity_by_date["absent"];
      let reflabelmeeting = [];
      let datescols = [];

      if (labels !== undefined && labels.length > 0) {
        labels.forEach((r, index) => {
          let days = r.split("-");
          day = new Date(days[0], days[1] - 1, days[2]);
          var refd = day.getFullYear() + "-" + days[1];

          if (reflabelmeeting.indexOf(refd) < 0) {
            datescols.push(refd);
            reflabelmeeting.push(refd);
          }
          indexof = reflabelmeeting.indexOf(refd);

          if (
            newplanned[indexof] == undefined &&
            planned[index] !== undefined
          ) {
            newplanned[indexof] = 0 + parseInt(planned[index]);
          } else {
            newplanned[indexof] =
              parseInt(newplanned[indexof]) + parseInt(planned[index]);
          }
          if (
            newcanceled[indexof] == undefined &&
            canceled[index] !== undefined
          ) {
            newcanceled[indexof] = 0 + parseInt(canceled[index]);
          } else {
            newcanceled[indexof] =
              parseInt(newcanceled[indexof]) + parseInt(canceled[index]);
          }
          if (newabsent[indexof] == undefined && absent[index] !== undefined) {
            newabsent[indexof] = 0 + parseInt(absent[index]);
          } else {
            newabsent[indexof] =
              parseInt(newabsent[indexof]) + parseInt(absent[index]);
          }
        });
      }

      if (
        newplanned !== null &&
        newplanned !== undefined &&
        newplanned.length > 0
      ) {
        newplanned.forEach((quantity, index) => {
          planned.push(quantity);
        });
        newcanceled.forEach((quantity, index) => {
          canceled.push(quantity);
        });
        newabsent.forEach((quantity, index) => {
          absent.push(quantity);
        });
        this.groupedmeetignsmonth.labels = datescols;
        this.groupedmeetignsmonth.datasets[0].data = planned;
        this.groupedmeetignsmonth.datasets[1].data = canceled;
        this.groupedmeetignsmonth.datasets[2].data = absent;
      }
    },
    getGroupWeek() {
      this.groupedmeetignsweek.labels = this.stats.activity_by_date.labels;
      this.groupedmeetignsweek.datasets[0].label = "Planned %";
      this.groupedmeetignsweek.datasets[1].label = "Canceled %";
      this.groupedmeetignsweek.datasets[2].label = "Absent %";

      let stats = this.stats;
      let labels = stats.activity_by_date.labels;
      let newplanned = [];
      let newcanceled = [];
      let newabsent = [];
      let indexof;
      let days = "";
      let day = "";
      let planned = this.stats.activity_by_date["plannedcant"];
      let canceled = this.stats.activity_by_date["canceledcant"];
      let absent = this.stats.activity_by_date["absentcant"];
      let reflabelmeeting = [];
      let datescols = [];

      if (labels !== null && labels !== undefined && labels.length > 0) {
        labels.forEach((r, index) => {
          let days = r.split("-");
          let day = new Date(days[0], days[1] - 1, days[2]);

          var d = new Date(
            Date.UTC(day.getFullYear(), day.getMonth(), day.getDate())
          );
          var dayNum = d.getUTCDay() || 7;
          d.setUTCDate(d.getUTCDate() + 4 - dayNum);
          var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
          var week = Math.ceil(((d - yearStart) / 86400000 + 1) / 7);

          if (days[1] + "/" + days[2] == "01/01") {
            week = 1;
          }
          if (days[1] + "/" + days[2] == "01/02") {
            week = 1;
          }

          var refd = day.getFullYear() + " Week: " + week;

          if (reflabelmeeting.indexOf(refd) < 0) {
            datescols.push(refd);
            reflabelmeeting.push(refd);
          }
          indexof = reflabelmeeting.indexOf(refd);

          if (
            newplanned[indexof] == undefined &&
            planned[index] !== undefined
          ) {
            newplanned[indexof] = 0 + parseInt(planned[index]);
          } else {
            newplanned[indexof] =
              parseInt(newplanned[indexof]) + parseInt(planned[index]);
          }
          if (
            newcanceled[indexof] == undefined &&
            canceled[index] !== undefined
          ) {
            newcanceled[indexof] = 0 + parseInt(canceled[index]);
          } else {
            newcanceled[indexof] =
              parseInt(newcanceled[indexof]) + parseInt(canceled[index]);
          }
          if (newabsent[indexof] == undefined && absent[index] !== undefined) {
            newabsent[indexof] = 0 + parseInt(absent[index]);
          } else {
            newabsent[indexof] =
              parseInt(newabsent[indexof]) + parseInt(absent[index]);
          }
        });
      }

      let resplanned = [];
      let rescanceled = [];
      let resabsent = [];

      if (
        newplanned !== null &&
        newplanned !== undefined &&
        newplanned.length > 0
      ) {
        newplanned.forEach((quantity, index) => {
          var total = newcanceled[index] + newabsent[index] + newplanned[index];
          var it = quantity;
          var q = Math.round((it * 100) / total);
          resplanned.push(q);
          it = newcanceled[index];
          var q = Math.round((it * 100) / total);
          rescanceled.push(q);
          it = newabsent[index];
          var q = Math.round((it * 100) / total);
          resabsent.push(q);
        });

        this.groupedmeetignsweek.labels = datescols;
        this.groupedmeetignsweek.datasets[0].data = resplanned;
        this.groupedmeetignsweek.datasets[1].data = rescanceled;
        this.groupedmeetignsweek.datasets[2].data = resabsent;
      }
    },
    getMultiaxisWeek(type) {
      let stats = this.stats;
      if (stats.activity_by_date[type] === undefined) {
        return;
      }
      let meetings = stats.activity_by_date[type];
      let labels = stats.activity_by_date.labels;
      let newlabels = [];
      let cantnewlabels = [];
      let indexof;
      let days = "";
      let day = "";
      let resmeetings = [];
      let reflabelmeeting = [];
      let datescols = [];

      var option = this.options.filter((c) => c.id == type);
      var isRate = option[0].isRate == undefined ? false : option[0].isRate;
      var format = option[0].format == undefined ? "integer" : option[0].format;

      if (labels !== null && labels !== undefined && labels.length > 0) {
        labels.forEach((r, index) => {
          let days = r.split("-");
          let day = new Date(days[0], days[1] - 1, days[2]);

          var d = new Date(
            Date.UTC(day.getFullYear(), day.getMonth(), day.getDate())
          );
          var dayNum = d.getUTCDay() || 7;
          d.setUTCDate(d.getUTCDate() + 4 - dayNum);
          var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
          var week = Math.ceil(((d - yearStart) / 86400000 + 1) / 7);

          if (days[1] + "-" + days[2] == "01-01") {
            week = 1;
          }
          if (days[1] + "-" + days[2] == "01-02") {
            week = 1;
          }

          var refd = day.getFullYear() + " Semana: " + week;

          if (reflabelmeeting.indexOf(refd) < 0) {
            datescols.push(day);
            reflabelmeeting.push(refd);
          }
          indexof = reflabelmeeting.indexOf(refd);

          if (
            newlabels[indexof] == undefined &&
            meetings[index] !== undefined && meetings[index] !== '-') {
            if (format === "float") {
              newlabels[indexof] = 0 + parseFloat(meetings[index]);
              // console.log("acumulado", newlabels[indexof])
              if (parseFloat(meetings[index]) > 0) {
                cantnewlabels[indexof] = 1;
              }
              // console.log("cantnewlabels", cantnewlabels[indexof])
            } else {
              newlabels[indexof] = 0 + parseInt(meetings[index]);
            }
          } else {
            if (format === "float" && meetings[index] !== '-') {
              newlabels[indexof] =
                parseFloat(newlabels[indexof]) + parseFloat(meetings[index]);
              // console.log("acumulado", newlabels[indexof])
              if (parseFloat(meetings[index]) > 0) {
                if (cantnewlabels[indexof] === undefined) {
                  cantnewlabels[indexof] = 1;
                } else {
                  cantnewlabels[indexof] += 1;
                }
              }
              // console.log("cantnewlabels", cantnewlabels[indexof])
            } else if (meetings[index] !== '-') {
              newlabels[indexof] =
                parseInt(newlabels[indexof]) + parseInt(meetings[index]);
            }
          }
        });

        if (isRate) {
          newlabels.forEach((r, index) => {
            newlabels[index] = parseFloat(r / cantnewlabels[index]).toFixed(4);
            // console.log("total", r);
            // console.log("qty", cantnewlabels[index]);
            // console.log("result", newlabels[index]);
          });
        }
      }

      if (
        newlabels !== null &&
        newlabels !== undefined &&
        newlabels.length > 0
      ) {
        newlabels.forEach((quantity, index) => {
          resmeetings.push(quantity);
        });
        this.multiaxisweek.labels = datescols;

        this.multiaxis.datasets.forEach((r, index) => {
          if (r.filter == type) {
            this.multiaxisweek.datasets[index].data = resmeetings;
          }
        });
      }
    },
    getMultiaxis() {
      if (!this.optselect || !Array.isArray(this.optselect)) {
        return;
      }
      this.optselect.forEach((r, index) => {
        if (r && r.id) {
          this.getMultiaxisMonth(r.id);
          this.getMultiaxisWeek(r.id);
        }
      });
    },
    refreshgmail() {
      this.loadinggmail = true;
      adminService.getGmailImports().then((result) => {
        this.gmaillist = result;
        this.keygmail++;
        this.loadinggmail = false;
      });
    },
    validarDate() {
      let startDate = new Date(this.range.startDate);
      let endDate = new Date(this.range.endDate);
      if (startDate.getTime() > endDate.getTime()) {
        return true;
      } else {
        return false;
      }
    },
    loadRangeStats(skipSendComplements = false) {
      if (
        !skipSendComplements &&
        this.filters.type.indexOf("sent") >= 0 &&
        this.filters.type.indexOf("bounce_total") < 0
      ) {
        let opt = ["bounce_total", "scheduled"];
        opt.forEach((item) => {
          this.filters.type.push(item);
          if (this.options[item]) {
            this.optselect.push(this.options[item]);
          }
        });
      }

      if (
        this.filters.type.indexOf("recurringsent") >= 0 &&
        this.filters.type.indexOf("recurringsent2") < 0
      ) {
        let opt = [
          "recurringsent2",
          "recurringsent3",
          "recurringsent4",
          "recurringsent5",
          "recurringsent6",
        ];
        opt.forEach((item) => {
          this.filters.type.push(item);
          if (this.options[item]) {
            this.optselect.push(this.options[item]);
          }
        });
      }

      if (
        this.filters.type.indexOf("meeting_qty") >= 0 &&
        this.filters.type.indexOf("cancel_rate") < 0
      ) {
        let opt = [
          "planned_qty",
          "charged_qty",
          "uncharged_qty",
          "declined_rate",
          "declined_qty",
          "cancel_rate",
          "cancel_qty",
          "absent_rate",
          "absent_qty",
        ];
        opt.forEach((item) => {
          this.filters.type.push(item);
          if (this.options[item]) {
            this.optselect.push(this.options[item]);
          }
        });
      }

      if (
        this.filters.type.indexOf("projsend") >= 0 &&
        this.filters.type.indexOf("projsend_new") < 0
      ) {
        let opt = [
          "projsend_new",
          "projsend_recurring",
          "projsend_recurring2",
          "projsend_recurring3",
          "projsend_recurring4",
          "projsend_recurring5",
          "projsend_recurring6",
          "projsend_meetings",
          "projsend_money"
        ];
        opt.forEach((item) => {
          this.filters.type.push(item);
          if (this.options[item]) {
            this.optselect.push(this.options[item]);
          }
        });
      }



      if (
        this.filters.type.indexOf("er_total") >= 0 &&
        this.filters.type.indexOf("er_positive") < 0
      ) {
        let opt = [
          "er_positive",
          "er_manualpositive",
          "er_introduction",
          "er_negative",
          "er_notscope",
          "er_wrong",
          "er_donotcontact",
          "er_nottaggued",
          "er_automatic",
        ];
        opt.forEach((item) => {
          this.filters.type.push(item);
          if (this.options[item]) {
            this.optselect.push(this.options[item]);
          }
        });
      }

      this.multiaxis.datasets = [];
      this.multiaxisweek.datasets = [];
      this.multiaxismonth.datasets = [];
      this.loadMultiaxis();
      this.meetings_details = [];
      this.openlist = false;
      this.openchart = true;

      if (this.clientId !== null) {
        this.clients.push(this.clientId);
      }
      if (this.validarDate() === true) {
        this.$swal({
          type: "warning",
          title: "Error!",
          text: "Start date should be less than end date. ",
          showCancelButton: false,
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Close",
        });
      } else {
        this.getCampaignStatsByIdAndRange({
          id: this.selCampaignId != undefined ? this.selCampaignId : 0,
          startDate: this.range.startDate,
          endDate: this.range.endDate,
          client: this.clients,
          filters: this.filters,
        });
      }
    },
    loadStatsData() {
      if (!this.loadingStats) {
        this.multiaxis.labels = this.stats.activity_by_date.labels;
        this.multiaxis.datasets.forEach((r, index) => {
          this.multiaxis.datasets[index].data =
            this.stats.activity_by_date[this.multiaxis.datasets[index].filter];
        });

        this.getMultiaxis();

        this.groupedmeetigns.labels = this.stats.activity_by_date.labels;
        this.groupedmeetigns.datasets[0].label = "Planned %";
        this.groupedmeetigns.datasets[1].label = "Canceled %";
        this.groupedmeetigns.datasets[2].label = "Absent %";
        this.groupedmeetigns.datasets[0].data =
          this.stats.activity_by_date["planned"];
        this.groupedmeetigns.datasets[1].data =
          this.stats.activity_by_date["canceled"];
        this.groupedmeetigns.datasets[2].data =
          this.stats.activity_by_date["absent"];

        this.getGroupWeek();
        this.getGroupMonth();
      }
    },
    getMoreTeam() {
      let actualcant = this.teamgroups.length;
      this.groups.forEach((r, index) => {
        if (index >= actualcant && index < actualcant + 10) {
          this.cantgroups++;
          this.teamgroups.push(r);
        }
      });
    },
    myTeamList() {
      if (this.clientId == null && this.hasPermissions("adminClients")) {
        monitorService.getClients().then((result) => {
          this.groups = result;
          result.forEach((r, index) => {
            if (index < 10) {
              this.cantgroups++;
              this.teamgroups.push(r);
            }
          });
        });
      } else {
        this.client = this.clientId;
        this.groups.push({ id: this.clientId, name: "yooo" });

        this.changeThisTab(1);
      }
    },
    refreshlinkedin() {
      this.loadinglinkedin = true;
      adminService.getLinkedinImports().then((result) => {
        this.linkedinlist = result;
        this.keylinkedin++;
        this.loadinglinkedin = false;
      });
    },
    goToClient(client_id) {
      let url = "/clients/" + client_id;
      window.open(url, "_blank");
    },
    goToOrder(target_id){
      let url = "/orders/" + target_id;
      window.open(url, "_blank");
    },
    filterNow(filter) {
      this.filtersDash = filter;
      this.loadAgencyStats();
    },

    searchOptions({ action, searchQuery, callback }) {
      if (action === ASYNC_SEARCH) {
        simulateAsyncOperation(() => {
          let options = this.groups.filter((option) =>
            option.label.toLowerCase().includes(searchQuery.toLowerCase())
          );
          if (options.length == 0) {
            let options = this.getChildren(this.groups).filter((option) =>
              option.label.toLowerCase().includes(searchQuery.toLowerCase())
            );
            if (options.length == 0) {
              let options = this.getChildren(
                this.getChildren(this.groups)
              ).filter((option) =>
                option.label.toLowerCase().includes(searchQuery.toLowerCase())
              );
              callback(null, options);
            }
            callback(null, options);
          }
          callback(null, options);
        });
      }
    },
  },
};
</script>
<style>
.scrollable {
  height: 50vh;
  overflow: scroll !important;
  width: 100% !important;
}

.vm--modal {
  overflow-y: scroll !important;
}

.img-buss {
  width: 25px;
  height: 25px;
}

.table-container {
  overflow-x: auto;
  /* Habilitar el desplazamiento horizontal */
  /* Evitar el ajuste de línea de las celdas */
}

.inline-table {
  display: inline-table !important;
}

.treeselect-wrapper .vue-treeselect__control {
  border: 0px !important;
  margin-top: -4px !important;
  height: 25px !important;
}

.stats-wrapper .input-group-prepend {
  display: block !important;
}

.stats-wrapper .btn-outline-primary.active {
  color: #fff !important;
}
</style>
